
(function() {
  var module = {};
  var result = {};
  module.exports = { "af": { "i18n": { "duration": { "seconds": "{{ seconds }} sekondes", "minutes": "{{ minutes }} minute", "hours": "{{ hours }} ure", "hoursAndMinutes": "{{ hours }} uur {{ minutes }} min", "days": "{{ days }} dae ", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}u", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}u{{ minutes }}m" } }, "dateTime": { "quarterAndYear": "{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, uitbr. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "af": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:af', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "ar-eg": { "i18n": { "duration": { "seconds": "{{ seconds }} \u062B\u0627\u0646\u064A\u0629", "minutes": "{{ minutes }} \u062F\u0642\u064A\u0642\u0629", "hours": "{{ hours }} \u0633\u0627\u0639\u0629", "hoursAndMinutes": "{{ hours }} \u0633\u0627\u0639\u0629 {{ minutes }} \u062F\u0642\u064A\u0642\u0629", "days": "{{ days }} \u0623\u064A\u0627\u0645", "shortForm": { "seconds": "{{ seconds }} \u062B", "minutes": "{{ minutes }} \u062F", "hours": "{{ hours }} \u0633", "days": "{{ days }} \u064A", "hoursAndMinutes": "{{ hours }} \u0633 {{ minutes }} \u062F" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}\u060C \u062A\u0645\u062F\u064A\u062F {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "ar-eg": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ar-eg', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "bg": { "i18n": { "duration": { "seconds": "{{ seconds }} \u0441\u0435\u043A", "minutes": "{{ minutes }} \u043C\u0438\u043D", "hours": "{{ hours }} \u0447", "hoursAndMinutes": "{{ hours }} \u0447 {{ minutes }} \u043C\u0438\u043D", "days": "{{ days }} \u0434\u043D\u0438", "shortForm": { "seconds": "{{ seconds }} \u0441\u0435\u043A", "minutes": "{{ minutes }} \u043C\u0438\u043D", "hours": "{{ hours }} \u0447", "days": "{{ days }} \u0434", "hoursAndMinutes": "{{ hours }} \u0447 {{ minutes }} \u043C\u0438\u043D" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, \u0432\u044A\u0442\u0440. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "bg": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:bg', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "bn": { "i18n": { "duration": { "seconds": "{{ seconds }}\u09B8\u09C7\u0995", "minutes": "{{ minutes }}\u09AE\u09BF\u09A8\u09BF\u099F", "hours": "{{ hours }}\u0998\u09A8\u09CD\u099F\u09BE", "hoursAndMinutes": "{{ hours }}\u0998\u09A8\u09CD\u099F\u09BE {{ minutes }}\u09AE\u09BF\u09A8\u09BF\u099F", "days": "{{ days }}\u09A6\u09BF\u09A8\xA0", "shortForm": { "seconds": "{{ seconds }}\u09B8\u09C7", "minutes": "{{ minutes }}\u09AE\u09BF\xA0", "hours": "{{ hours }}\u0998", "days": "{{ days }}\u09A6\u09BF\xA0", "hoursAndMinutes": "{{ hours }}\u0998 {{ minutes }}\u09AE\u09BF" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}}{{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}}{{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}},\u098F\u0995\u09CD\u09B8\u099F.{{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "bn": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:bn', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "ca-es": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} dies", "shortForm": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "days": "{{ days }} d", "hoursAndMinutes": "{{ hours }} h {{ minutes }} m" } }, "dateTime": { "quarterAndYear": "T {{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "ca-es": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ca-es', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "cs": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hod", "hoursAndMinutes": "{{ hours }} hod {{ minutes }} min", "days": "{{ days }} d", "shortForm": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} m", "hours": "{{ hours }} h", "days": "{{ days }} d", "hoursAndMinutes": "{{ hours }} h {{ minutes }} m" } }, "dateTime": { "quarterAndYear": "Q {{quarterNumber}}{{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}}{{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, linka {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "cs": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:cs', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "da": { "i18n": { "duration": { "seconds": "{{ seconds }} sek.", "minutes": "{{ minutes }}min.", "hours": "{{ hours }}t.", "hoursAndMinutes": "{{ hours }}t. {{ minutes }}min.", "days": "{{ days }}dg", "shortForm": { "seconds": "{{ seconds }}sek.", "minutes": "{{ minutes }}min.", "hours": "{{ hours }}t", "days": "{{ days }}dg", "hoursAndMinutes": "{{ hours }}t {{ minutes }}min." } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, lokal {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "da": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:da', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "de": { "i18n": { "duration": { "seconds": "{{ seconds }} Sek.", "minutes": "{{ minutes }} Min.", "hours": "{{ hours }} Std.", "hoursAndMinutes": "{{ hours }} Std. {{ minutes }} Min.", "days": "{{ days }} Tage", "shortForm": { "seconds": "{{ seconds }} Sek.", "minutes": "{{ minutes }} Min.", "hours": "{{ hours }} Std.", "days": "{{ days }} Tage", "hoursAndMinutes": "{{ hours }} Std. {{ minutes }} Min." } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, Durchwahl {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "de": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:de', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "el": { "i18n": { "duration": { "seconds": "{{ seconds }} \u03B4\u03B5\u03C5\u03C4.", "minutes": "{{ minutes }} \u03BB\u03B5\u03C0\u03C4.", "hours": "{{ hours }} \u03CE\u03C1.", "hoursAndMinutes": "{{ hours }} \u03CE\u03C1. {{ minutes }} \u03BB\u03B5\u03C0\u03C4.", "days": "{{ days }} \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2", "shortForm": { "seconds": "{{ seconds }}\u03B4.", "minutes": "{{ minutes }}\u03BB.", "hours": "{{ hours }}\u03CE\u03C1.", "days": "{{ days }}\u03B7\u03BC.", "hoursAndMinutes": "{{ hours }}\u03CE\u03C1. {{ minutes }}\u03BB." } }, "dateTime": { "quarterAndYear": "{{quarterNumber}}\u03BF \u03C4\u03C1\u03AF\u03BC. {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, \u03B5\u03C3\u03C9\u03C4. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "el": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:el', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en-gb": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hr", "hoursAndMinutes": "{{ hours }} hr {{ minutes }} min", "days": "{{ days }} days", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "en-gb": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:en-gb', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hr", "hoursAndMinutes": "{{ hours }} hr {{ minutes }} min", "days": "{{ days }} days", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "en": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:en', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "es-mx": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} d\xEDas", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "es-mx": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:es-mx', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "es": { "i18n": { "duration": { "seconds": "{{ seconds }} seg", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} d\xEDas", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "es": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:es', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "fi": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} vrk", "shortForm": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "days": "{{ days }} vrk", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min" } }, "dateTime": { "quarterAndYear": "K{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{amountNumberValue}} {{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}}, alanro {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "fi": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:fi', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "fr-ca": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} jours", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h{{ minutes }}m" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{amountNumberValue}} {{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}}, poste {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "fr-ca": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:fr-ca', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "fr": { "i18n": { "duration": { "seconds": "{{ seconds }}\xA0s", "minutes": "{{ minutes }}\xA0min", "hours": "{{ hours }}\xA0h", "hoursAndMinutes": "{{ hours }}\xA0h {{ minutes }}\xA0min", "days": "{{ days }}\xA0jours", "shortForm": { "seconds": "{{ seconds }}\xA0s", "minutes": "{{ minutes }}\xA0m", "hours": "{{ hours }}\xA0h", "days": "{{ days }}\xA0j", "hoursAndMinutes": "{{ hours }}\xA0h {{ minutes }}\xA0m" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "fr": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:fr', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "he-il": { "i18n": { "duration": { "seconds": "{{ seconds }} \u05E9\u05E0\u05D9\u05D5\u05EA", "minutes": "{{ minutes }} \u05D3\u05E7\u05D5\u05EA", "hours": "{{ hours }} \u05E9\u05E2\u05D5\u05EA", "hoursAndMinutes": "{{ hours }} \u05E9\u05E2\u05D5\u05EA {{ minutes }} \u05D3\u05E7\u05D5\u05EA", "days": "{{ days }} \u05D9\u05DE\u05D9\u05DD", "shortForm": { "seconds": "{{ seconds }} \u05E9\u05E0'", "minutes": "{{ minutes }} \u05D3\u05E7'", "hours": "{{ hours }} \u05E9\u05E2'", "days": "{{ days }} \u05D9\u05DE'", "hoursAndMinutes": "{{ hours }} \u05E9\u05E2' {{ minutes }} \u05D3\u05E7'" } }, "dateTime": { "quarterAndYear": "\u05E8\u05D1\u05E2\u05D5\u05DF{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{amountNumberValue}} {{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}}, \u05E9\u05DC\u05D5\u05D7\u05D4 {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "he-il": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:he-il', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "hr": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min.", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min.", "days": "{{ days }} dana", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, lok. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "hr": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:hr', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "hu": { "i18n": { "duration": { "seconds": "{{ seconds }} mp.", "minutes": "{{ minutes }} p.", "hours": "{{ hours }} \xF3.", "hoursAndMinutes": "{{ hours }} \xF3. {{ minutes }} p.", "days": "{{ days }} nap", "shortForm": { "seconds": "{{ seconds }} mp", "minutes": "{{ minutes }} p", "hours": "{{ hours }} \xF3", "days": "{{ days }} n", "hoursAndMinutes": "{{ hours }} \xF3 {{ minutes }} p" } }, "dateTime": { "quarterAndYear": "{{yearNumber}}. {{quarterNumber}}. n\xE9." }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{amountNumberValue}} {{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}}, {{extension}} mell\xE9k" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "hu": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:hu', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "id": { "i18n": { "duration": { "seconds": "{{ seconds }} dtk", "minutes": "{{ minutes }}  mnt", "hours": "{{ hours }} jam", "hoursAndMinutes": "{{ hours }} jam {{ minutes }} mnt", "days": "{{ days }} hari", "shortForm": { "seconds": "{{ seconds }}d", "minutes": "{{ minutes }}m", "hours": "{{ hours }}j", "days": "{{ days }}h", "hoursAndMinutes": "{{ hours }}j {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "K{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "id": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:id', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "it": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} gg", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}g", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, est. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "it": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:it', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "ja": { "i18n": { "duration": { "seconds": "{{ seconds }}\u79D2", "minutes": "{{ minutes }}\u5206", "hours": "{{ hours }}\u6642\u9593", "hoursAndMinutes": "{{ hours }}\u6642\u9593{{ minutes }}\u5206", "days": "{{ days }}\u65E5", "shortForm": { "seconds": "{{ seconds }}\u79D2", "minutes": "{{ minutes }}\u5206", "hours": "{{ hours }}\u6642\u9593", "days": "{{ days }}\u65E5", "hoursAndMinutes": "{{ hours }}\u6642\u9593{{ minutes }}\u5206" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}\u3001\u5185\u7DDA\u756A\u53F7{{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "ja": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ja', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "ko": { "i18n": { "duration": { "seconds": "{{ seconds }}\uCD08", "minutes": "{{ minutes }}\uBD84", "hours": "{{ hours }}\uC2DC\uAC04", "hoursAndMinutes": "{{ hours }}\uC2DC\uAC04 {{ minutes }}\uBD84", "days": "{{ days }}\uC77C", "shortForm": { "seconds": "{{ seconds }}\uCD08", "minutes": "{{ minutes }}\uBD84", "hours": "{{ hours }}\uC2DC\uAC04", "days": "{{ days }}\uC77C", "hoursAndMinutes": "{{ hours }}\uC2DC\uAC04 {{ minutes }}\uBD84" } }, "dateTime": { "quarterAndYear": "{{yearNumber}} {{quarterNumber}}\uBD84\uAE30" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}}{{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, \uB0B4\uC120\uBC88\uD638: {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "ko": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ko', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "lt": { "i18n": { "duration": { "seconds": "{{ seconds }} sek.", "minutes": "{{ minutes }} min.", "hours": "{{ hours }} val.", "hoursAndMinutes": "{{ hours }} val. {{ minutes }} min.", "days": "{{ days }} d.", "shortForm": { "seconds": "{{ seconds }} sek.", "minutes": "{{ minutes }} min.", "hours": "{{ hours }} val.", "days": "{{ days }} d.", "hoursAndMinutes": "{{ hours }} val. {{ minutes }} min." } }, "dateTime": { "quarterAndYear": "{{yearNumber}} m. {{quarterNumber}} ketv." }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{amountNumberValue}} {{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}}, pl\u0117t. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "lt": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:lt', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "nl": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} uur", "hoursAndMinutes": "{{ hours }} uur {{ minutes }} min", "days": "{{ days }} dagen", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}u", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}u {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "K{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "nl": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:nl', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "no-no": { "i18n": { "duration": { "seconds": "{{ seconds }} sek", "minutes": "{{ minutes }} min", "hours": "{{ hours }} tm", "hoursAndMinutes": "{{ hours }} tm {{ minutes }} min", "days": "{{ days }} dager", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}t", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}t {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, utvidelse {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "no": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:no', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "pl": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }}min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} dni", "shortForm": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} godz", "days": "{{ days }} dn.", "hoursAndMinutes": "{{ hours }} godz. {{ minutes }} min" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{amountNumberValue}} {{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}}, rozsz. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "pl": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:pl', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "pt-br": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} m", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} m", "days": "{{ days }} dias", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ramal {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "pt-br": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:pt-br', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "pt-pt": { "i18n": { "duration": { "seconds": "{{ seconds }} seg.", "minutes": "{{ minutes }} min.", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min.", "days": "{{ days }} dias", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} de {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{amountNumberValue}} {{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "pt-pt": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:pt-pt', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "ro": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} ore", "hoursAndMinutes": "{{ hours }} ore {{ minutes }} min", "days": "{{ days }} zile", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}z", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "ro": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ro', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "ru": { "i18n": { "duration": { "seconds": "{{ seconds }} \u0441", "minutes": "{{ minutes }} \u043C\u0438\u043D", "hours": "{{ hours }} \u0447", "hoursAndMinutes": "{{ hours }} \u0447 {{ minutes }} \u043C\u0438\u043D", "days": "{{ days }} \u0434\u043D.", "shortForm": { "seconds": "{{ seconds }}\u0441", "minutes": "{{ minutes }}\u043C", "hours": "{{ hours }}\u0447", "days": "{{ days }}\u0434", "hoursAndMinutes": "{{ hours }}\u0447 {{ minutes }}\u043C" } }, "dateTime": { "quarterAndYear": "\u041A\u0432.{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, \u0434\u043E\u0431\u0430\u0432. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "ru": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ru', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "sk": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min.", "hours": "{{ hours }} hod.", "hoursAndMinutes": "{{ hours }} hod. {{ minutes }} min.", "days": "{{ days }} d.", "shortForm": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min.", "hours": "{{ hours }} hod.", "days": "{{ days }} d.", "hoursAndMinutes": "{{ hours }} hod. {{ minutes }} min." } }, "dateTime": { "quarterAndYear": "Kvart\xE1l {{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, klapka {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "sk": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:sk', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "sl": { "i18n": { "duration": { "seconds": "{{ seconds }} sekund", "minutes": "{{ minutes }} min", "hours": "{{ hours }} ur", "hoursAndMinutes": "{{ hours }} ur {{ minutes }} minut", "days": "{{ days }} dni", "shortForm": { "seconds": "{{ seconds }} sekund", "minutes": "{{ minutes }} minut", "hours": "{{ hours }} ur", "days": "{{ days }} dni", "hoursAndMinutes": "{{ hours }} ur {{ minutes }} minut" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, zun. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "sl": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:sl', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "sv": { "i18n": { "duration": { "seconds": "{{ seconds }} sek", "minutes": "{{ minutes }} min", "hours": "{{ hours }} tim", "hoursAndMinutes": "{{ hours }} tim {{ minutes }} min", "days": "{{ days }} dagar", "shortForm": { "seconds": "{{ seconds }}sek", "minutes": "{{ minutes }}min", "hours": "{{ hours }}tim", "days": "{{ days }}dagar", "hoursAndMinutes": "{{ hours }}tim {{ minutes }}min" } }, "dateTime": { "quarterAndYear": "F{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }} / {{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, anknytning {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "sv": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:sv', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "th": { "i18n": { "duration": { "seconds": "{{ seconds }} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35", "minutes": "{{ minutes }} \u0E19\u0E32\u0E17\u0E35", "hours": "{{ hours }} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07", "hoursAndMinutes": "{{ hours }} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07 {{ minutes }} \u0E19\u0E32\u0E17\u0E35", "days": "{{ days }} \u0E27\u0E31\u0E19", "shortForm": { "seconds": "{{ seconds }} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35", "minutes": "{{ minutes }} \u0E19\u0E32\u0E17\u0E35", "hours": "{{ hours }} \u0E0A\u0E21.", "days": "{{ days }} \u0E27\u0E31\u0E19", "hoursAndMinutes": "{{ hours }} \u0E0A\u0E21. {{ minutes }} \u0E19\u0E32\u0E17\u0E35" } }, "dateTime": { "quarterAndYear": "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A {{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{amountNumberValue}} {{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}} \u0E15\u0E48\u0E2D {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "th": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:th', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "tr": { "i18n": { "duration": { "seconds": "{{ seconds }} sn.", "minutes": "{{ minutes }} dk.", "hours": "{{ hours }} sa.", "hoursAndMinutes": "{{ hours }} sa. {{ minutes }} dk.", "days": "{{ days }} g\xFCn", "shortForm": { "seconds": "{{ seconds }}sn.", "minutes": "{{ minutes }}dk.", "hours": "{{ hours }}sa.", "days": "{{ days }}g\xFCn", "hoursAndMinutes": "{{ hours }}sa. {{ minutes }}dk." } }, "dateTime": { "quarterAndYear": "{{quarterNumber}}. \xC7 {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, dahili {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "tr": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:tr', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "uk": { "i18n": { "duration": { "seconds": "{{ seconds }} \u0441\u0435\u043A\u0443\u043D\u0434", "minutes": "{{ minutes }} \u0445\u0432\u0438\u043B\u0438\u043D", "hours": "{{ hours }} \u0433\u043E\u0434\u0438\u043D", "hoursAndMinutes": "{{ hours }} \u0433\u043E\u0434\u0438\u043D {{ minutes }} \u0445\u0432\u0438\u043B\u0438\u043D", "days": "{{ days }} \u0434\u043D\u0456\u0432", "shortForm": { "seconds": "{{ seconds }}\u0441", "minutes": "{{ minutes }}\u0445\u0432", "hours": "{{ hours }}\u0433\u043E\u0434", "days": "{{ days }}\u0434", "hoursAndMinutes": "{{ hours }}\u0433\u043E\u0434 {{ minutes }}\u0445\u0432" } }, "dateTime": { "quarterAndYear": "\u041A\u0432.{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, \u0434\u043E\u0434. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "uk": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:uk', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "vi": { "i18n": { "duration": { "seconds": "{{ seconds }} gi\xE2y", "minutes": "{{ minutes }} ph\xFAt", "hours": "{{ hours }} gi\u1EDD", "hoursAndMinutes": "{{ hours }} gi\u1EDD {{ minutes }} ph\xFAt", "days": "{{ days }} ng\xE0y", "shortForm": { "seconds": "{{ seconds }} gi\xE2y", "minutes": "{{ minutes }} ph\xFAt", "hours": "{{ hours }} gi\u1EDD", "days": "{{ days }} ng\xE0y", "hoursAndMinutes": "{{ hours }} gi\u1EDD {{ minutes }} ph\xFAt" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{amountNumberValue}} {{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}}, m\xE1y l\u1EBB {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "vi": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:vi', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "zh-cn": { "i18n": { "duration": { "seconds": "{{ seconds }} \u79D2", "minutes": "{{ minutes }} \u5206\u949F", "hours": "{{ hours }} \u5C0F\u65F6", "hoursAndMinutes": "{{ hours }} \u5C0F\u65F6 {{ minutes }} \u5206\u949F", "days": "{{ days }} \u5929", "shortForm": { "seconds": "{{ seconds }} \u79D2", "minutes": "{{ minutes }} \u5206\u949F", "hours": "{{ hours }} \u5C0F\u65F6", "days": "{{ days }} \u5929", "hoursAndMinutes": "{{ hours }} \u5C0F\u65F6 {{ minutes }} \u5206\u949F" } }, "dateTime": { "quarterAndYear": "{{yearNumber}} \u5E74\u7B2C {{quarterNumber}} \u5B63\u5EA6" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}\uFF0C\u5206\u673A {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "zh-cn": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:zh-cn', {version: 'static-7.705'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "zh-hk": { "i18n": { "duration": { "seconds": "{{ seconds }} \u79D2", "minutes": "{{ minutes }} \u5206\u9418", "hours": "{{ hours }} \u5C0F\u6642", "hoursAndMinutes": "{{ hours }} \u5C0F\u6642 {{ minutes }} \u5206\u9418", "days": "{{ days }} \u65E5", "shortForm": { "seconds": "{{ seconds }} \u79D2", "minutes": "{{ minutes }} \u5206", "hours": "{{ hours }} \u5C0F\u6642", "days": "{{ days }} \u65E5", "hoursAndMinutes": "{{ hours }} \u5C0F\u6642 {{ minutes }} \u5206" } }, "dateTime": { "quarterAndYear": "{{yearNumber}} \u5E74\u7B2C {{quarterNumber}} \u5B63 " }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "zh-hk": "static-7.705"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.705",
    "ar-eg": "static-7.705",
    "bg": "static-7.705",
    "bn": "static-7.705",
    "ca-es": "static-7.705",
    "cs": "static-7.705",
    "da": "static-7.705",
    "de": "static-7.705",
    "el": "static-7.705",
    "en-gb": "static-7.705",
    "en": "static-7.705",
    "es-mx": "static-7.705",
    "es": "static-7.705",
    "fi": "static-7.705",
    "fr-ca": "static-7.705",
    "fr": "static-7.705",
    "he-il": "static-7.705",
    "hr": "static-7.705",
    "hu": "static-7.705",
    "id": "static-7.705",
    "it": "static-7.705",
    "ja": "static-7.705",
    "ko": "static-7.705",
    "lt": "static-7.705",
    "nl": "static-7.705",
    "no": "static-7.705",
    "pl": "static-7.705",
    "pt-br": "static-7.705",
    "pt-pt": "static-7.705",
    "ro": "static-7.705",
    "ru": "static-7.705",
    "sk": "static-7.705",
    "sl": "static-7.705",
    "sv": "static-7.705",
    "th": "static-7.705",
    "tr": "static-7.705",
    "uk": "static-7.705",
    "vi": "static-7.705",
    "zh-cn": "static-7.705",
    "zh-hk": "static-7.705"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:zh-hk', {version: 'static-7.705'}); }
})();


// I18n.js
// =======
//
// This small library provides the Rails I18n API on the Javascript.
// You don't actually have to use Rails (or even Ruby) to use I18n.js.
// Just make sure you export all translations in an object like this:
//
//     I18n.translations.en = {
//       hello: "Hello World"
//     };
//
// See tests for specific formatting like numbers and dates.
//
// Orignally pulled from https://raw.github.com/fnando/i18n-js/rewrite/app/assets/javascripts/i18n.js
// v3.0.0.rc11 (commit ab4bc2a).
//
// All custom HubSpot modifications are surrounded by comments and have been
// made while the file was in this repo.
//
;(function(I18n){
  "use strict";

  // Just cache the Array#slice function.
  var slice = Array.prototype.slice;

  // Apply number padding.
  var padding = function(number) {
    return ("0" + number.toString()).substr(-2);
  };

  // Set default days/months translations.
  var DATE = {
      day_names: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
    , abbr_day_names: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
    , month_names: [null, "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    , abbr_month_names: [null, "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    , meridian: ["AM", "PM"]
  };

  // Set default number format.
  var NUMBER_FORMAT = {
      precision: 3
    , separator: "."
    , delimiter: ","

    // HACK, HubSpot customizations to default number format
    // (more info at https://git.hubteam.com/HubSpot/I18n/commit/32fdaf1abad25b3b937a2947a83d788603636841 and https://git.hubteam.com/HubSpot/I18n/commit/7cff88e13955e56cf0f373480f3b04e7fc8b0512)
    // It would be much nicer if we could change these defaults without having to touch i18n.js (similar to existingOptions?)

    // , strip_insignificant_zeros: false
    , strip_insignificant_zeros: true
    // END HACK
  };

  // Set default currency format.
  var CURRENCY_FORMAT = {
      unit: "$"
    , precision: 2
    , format: "%u%n"
    , sign_first: true
    , delimiter: ","
    , separator: "."
  };

  // Set default percentage format.
  var PERCENTAGE_FORMAT = {
      unit: "%"
    , precision: 3
    , format: "%n%u"
    , separator: "."
    , delimiter: ""
  };

  // Set default size units.
  var SIZE_UNITS = [null, "kb", "mb", "gb", "tb"];

  // Other default options
  var DEFAULT_OPTIONS = {
    // Set default locale. This locale will be used when fallback is enabled and
    // the translation doesn't exist in a particular locale.
      defaultLocale: "en"
    // Set the current locale to `en`.
    , locale: "en"
    // Set the translation key separator.
    , defaultSeparator: "."
    // Set the placeholder format. Accepts `{placeholder}}` and `%{placeholder}`.}

    // HACK, HubSpot accepts whitespace: `{{ placeholder }}` or `{{placeholder}}` are equivalent
    // , placeholder: /(?:\{\{|%\{)(.*?)(?:\}\}?)/gm
    , placeholder: /(?:\{\{)\s?(\S*?)\s?(?:\}\})/gm

    // Set if engine should fallback to the default locale when a translation
    // is missing.
    , fallbacks: false
    // Set the default translation object.
    , translations: {}
    // Set missing translation behavior. 'message' will display a message
    // that the translation is missing, 'guess' will try to guess the string
    , missingBehaviour: 'message'
    // if you use missingBehaviour with 'message', but want to know that the
    // string is actually missing for testing purposes, you can prefix the
    // guessed string by setting the value here. By default, no prefix!
    , missingTranslationPrefix: ''
  };

  // Custom HubSpot logic to log key usage
  var keysUsed = {};
  var fallbackKeys = [];
  var keyUsedTimeout;
  var shouldLogUsage = Math.random() <= 0.05;
  function logKeyUsage(key, usedFallbackTranslation, requestedLocaleValue) {
    var hasSetKeysUsed = false;
    function setKeysUsed(newKey) {
      if (!hasSetKeysUsed) {
        keysUsed[newKey] = keysUsed[newKey] ? keysUsed[newKey] + 1 : 1;
      }
      hasSetKeysUsed = true;
    }

    try {
      if (localStorage.getItem('TRACK_I18N_MISSING_TRANSLATIONS')) {
        setKeysUsed(key);
        var currentProject = window.hubspot.bender.currentProject;
        var currentVersion = window.hubspot.bender.currentProjectVersion;
        localStorage.setItem('I18N_KEYS_USED:' + currentProject + ':' + currentVersion, JSON.stringify(keysUsed));

        var lsAppsTracked = localStorage.getItem('I18N_APPS_TRACKED');
        var trackedApps = {};
        var shouldUpdateTrackedApps = true;
        if (lsAppsTracked) {
          trackedApps = JSON.parse(lsAppsTracked);
          if (trackedApps[currentProject] && trackedApps[currentProject].indexOf(currentVersion) < 0) {
            trackedApps[currentProject].push(currentVersion);
          } else {
            shouldUpdateTrackedApps = false;
          }
        } else {
          trackedApps[currentProject] = [currentProject];
        }
        if (shouldUpdateTrackedApps) {
          localStorage.setItem('I18N_APPS_TRACKED', JSON.stringify(trackedApps));
        }
      }

      if (usedFallbackTranslation) {
        if (localStorage.getItem('TRACK_I18N_FALLBACK_TRANSLATIONS')) {
          var i18nFallbackTranslations = localStorage.getItem('TRACK_I18N_FALLBACK_TRANSLATIONS');
          if (!i18nFallbackTranslations) {
            i18nFallbackTranslations = key;
          } else {
            i18nFallbackTranslations = i18nFallbackTranslations.concat(',', key);
          }
          localStorage.setItem('I18N_FALLBACK_TRANSLATIONS', i18nFallbackTranslations);
        }
      }
    } catch (e) {}


    if (!shouldLogUsage) {
      return;
    }
    clearTimeout(keyUsedTimeout);

    setKeysUsed(key);

    if (usedFallbackTranslation && fallbackKeys.indexOf(key) === -1) {
      fallbackKeys.push(key);
    }

    keyUsedTimeout = setTimeout(function() {
      if (window.newrelic) {
        window.newrelic.addPageAction('i18nKeysUsed', {
          keysUsed: JSON.stringify(keysUsed),
          i18nKeyCount: Object.keys(keysUsed).length,
          fallbackKeys: JSON.stringify(fallbackKeys),
          englishFallbackCount: fallbackKeys.length,
          requestedLocaleValue: requestedLocaleValue
        });
      }

      // Don't leak memory if the tab stays open forever.
      shouldLogUsage = false;
      keysUsed = {};
    }, 1000 * 60);
  }
  // End custom HubSpot Logic

  I18n.reset = function() {
    // Set default locale. This locale will be used when fallback is enabled and
    // the translation doesn't exist in a particular locale.
    this.defaultLocale = DEFAULT_OPTIONS.defaultLocale;

    // Set the current locale to `en`.
    this.locale = DEFAULT_OPTIONS.locale;

    // Set the translation key separator.
    this.defaultSeparator = DEFAULT_OPTIONS.defaultSeparator;

    // Set the placeholder format. Accepts `{{placeholder}}` and `%{placeholder}`.
    this.placeholder = DEFAULT_OPTIONS.placeholder;

    // Set if engine should fallback to the default locale when a translation
    // is missing.
    this.fallbacks = DEFAULT_OPTIONS.fallbacks;

    // Set the default translation object.
    this.translations = DEFAULT_OPTIONS.translations;

    // Set the default missing behaviour
    this.missingBehaviour = DEFAULT_OPTIONS.missingBehaviour;

    // Set the default missing string prefix for guess behaviour
    this.missingTranslationPrefix = DEFAULT_OPTIONS.missingTranslationPrefix;

  };

  // Much like `reset`, but only assign options if not already assigned
  I18n.initializeOptions = function() {
    if (typeof(this.defaultLocale) === "undefined" && this.defaultLocale !== null)
      this.defaultLocale = DEFAULT_OPTIONS.defaultLocale;

    if (typeof(this.locale) === "undefined" && this.locale !== null)
      this.locale = DEFAULT_OPTIONS.locale;

    if (typeof(this.defaultSeparator) === "undefined" && this.defaultSeparator !== null)
      this.defaultSeparator = DEFAULT_OPTIONS.defaultSeparator;

    if (typeof(this.placeholder) === "undefined" && this.placeholder !== null)
      this.placeholder = DEFAULT_OPTIONS.placeholder;

    if (typeof(this.fallbacks) === "undefined" && this.fallbacks !== null)
      this.fallbacks = DEFAULT_OPTIONS.fallbacks;

    if (typeof(this.translations) === "undefined" && this.translations !== null)
      this.translations = DEFAULT_OPTIONS.translations;
  };
  I18n.initializeOptions();

  // Return a list of all locales that must be tried before returning the
   // missing translation message. By default, this will consider the inline option,
   // current locale and fallback locale.
   //
   //     I18n.locales.get("de-DE");
   //     // ["de-DE", "de", "en"]
   //
   // You can define custom rules for any locale. Just make sure you return a array
   // containing all locales.
   //
   //     // Default the Wookie locale to English.
   //     I18n.locales["wk"] = function(locale) {
   //       return ["en"];
   //     };
   //
   I18n.locales = {};

   // Retrieve locales based on inline locale, current locale or default to
   // I18n's detection.
   I18n.locales.get = function(locale) {
     var result = this[locale] || this[I18n.locale] || this["default"];

     if (typeof(result) === "function") {
       result = result(locale);
     }

     if (result instanceof Array === false) {
       result = [result];
     }

     return result;
   };

   // The default locale list.
   I18n.locales["default"] = function(locale) {
     var locales = []
       , list = []
       , countryCode
       , count
     ;

     // Handle the inline locale option that can be provided to
     // the `I18n.t` options.
     if (locale) {
       locales.push(locale);
     }

     // Add the current locale to the list.
     if (!locale && I18n.locale) {
       locales.push(I18n.locale);
     }

     // HACK, Handle invalid Norwegian keys
     if (locale === 'noNO' || (!locale && I18n.locale === 'noNO')) {
       locales.push('no-no');
     } else if (locale === 'no-no' || (!locale && I18n.locale === 'no-no')) {
       locales.push('noNO');
     }
     // END HACK

     // Add the default locale if fallback strategy is enabled.
     if (I18n.fallbacks && I18n.defaultLocale) {
       locales.push(I18n.defaultLocale);
     }

     // Compute each locale with its country code.
     // So this will return an array containing both
     // `de-DE` and `de` locales.
     locales.forEach(function(locale){
       countryCode = locale.split("-")[0];

       if (!~list.indexOf(locale)) {
         list.push(locale);
       }

      // HubSpot Hack: Fall back lowercase locales (pt-BR to pt-br) I18n/473
      if (!~list.indexOf(locale.toLowerCase())) {
        list.push(locale.toLowerCase());
      }
      // End Hack

       if (I18n.fallbacks && countryCode && countryCode !== locale && !~list.indexOf(countryCode)) {
         list.push(countryCode);
       }
     });

     // No locales set? English it is.
     if (!locales.length) {
       locales.push("en");
     }

     return list;
   };

  // Hold pluralization rules.
  I18n.pluralization = {};

  // Return the pluralizer for a specific locale.
  // If no specify locale is found, then I18n's default will be used.
  I18n.pluralization.get = function(locale) {
    return this[locale] || this[I18n.locale] || this["default"];
  };

  // The default pluralizer rule.
  // It detects the `zero`, `one`, and `other` scopes.
  I18n.pluralization["default"] = function(count) {
    switch (count) {
      case 0: return ["zero", "other"];

      // HACK, HubSpot customization, more info at https://git.hubteam.com/HubSpot/I18n/commit/c1debccf2409a358b5456830c472ae78ece5e634#commitcomment-8149
      // case 1: return ["one"];
      case 1: return ["one", "other"];
      // END HACK

      default: return ["other"];
    }
  };

  // Return current locale. If no locale has been set, then
  // the current locale will be the default locale.
  I18n.currentLocale = function() {
    return this.locale || this.defaultLocale;
  };

  // Check if value is different than undefined and null;
  I18n.isSet = function(value) {
    return value !== undefined && value !== null;
  };

  // Find and process the translation using the provided scope and options.
  // This is used internally by some functions and should not be used as an
  // public API.
  I18n.lookup = function(scope, options) {
    options = this.prepareOptions(options);

    var locales = this.locales.get(options.locale).slice()
      , requestedLocale = locales[0]
      , locale
      , scopes
      , translations
    ;

    scope = this.getFullScope(scope, options);

    while (locales.length) {
      locale = locales.shift();
      scopes = scope.split(this.defaultSeparator);
      translations = this.translations[locale];

      if (!translations) {
        continue;
      }

      while (scopes.length) {
        translations = translations[scopes.shift()];

        if (translations === undefined || translations === null) {
          break;
        }
      }

      var getJustLangValue = function(locale) {
        return locale.split('-')[0];
      }
      var requestedLocaleValue = getJustLangValue(requestedLocale);

      if (translations !== undefined && translations !== null) {
        // HubSpot logic to track key usage and English fallback
        var translationLocaleFound = getJustLangValue(locale);
        var isNotRequestedLocale = requestedLocaleValue !== translationLocaleFound;
        var isFallbackLocale = translationLocaleFound === this.defaultLocale;
        logKeyUsage(scope, this.langEnabled && isNotRequestedLocale && isFallbackLocale, requestedLocaleValue);
        // End HubSpot logic to track English fallback
        return translations;
      }
    }

    // Custom HubSpot logic to log key usage
    logKeyUsage(scope, false, requestedLocaleValue);

    if (this.isSet(options.defaultValue)) {
      return options.defaultValue;
    }
  };

  // Rails changed the way the meridian is stored.
  // It started with `date.meridian` returning an array,
  // then it switched to `time.am` and `time.pm`.
  // This function abstracts this difference and returns
  // the correct meridian or the default value when none is provided.
  I18n.meridian = function() {
    var time = this.lookup("time");
    var date = this.lookup("date");

    if (time && time.am && time.pm) {
      return [time.am, time.pm];
    } else if (date && date.meridian) {
      return date.meridian;
    } else {
      return DATE.meridian;
    }
  };

  // Merge serveral hash options, checking if value is set before
  // overwriting any value. The precedence is from left to right.
  //
  //     I18n.prepareOptions({name: "John Doe"}, {name: "Mary Doe", role: "user"});
  //     #=> {name: "John Doe", role: "user"}
  //
  I18n.prepareOptions = function() {
    var args = slice.call(arguments)
      , options = {}
      , subject
    ;

    while (args.length) {
      subject = args.shift();

      if (typeof(subject) != "object") {
        continue;
      }

      for (var attr in subject) {
        if (!subject.hasOwnProperty(attr)) {
          continue;
        }

        if (this.isSet(options[attr])) {
          continue;
        }

        options[attr] = subject[attr];
      }
    }

    return options;
  };

  // HACK, HubSpot fix

  // Steal Underscore's isObject implementation to deal with node not correctly respecting
  // `x instanceof Object` across different requires.
  var isObject = function(obj) {
    return obj === Object(obj);
  };

  // END HACK

  // Translate the given scope with the provided options.
  I18n.translate = function(scope, options) {
    options = this.prepareOptions(options);
    var translation = this.lookup(scope, options);

    // HACK: If the translation in this locale is a non-pluralization object, try
    // falling back on the default locale. Otherwise we'd just render "[object Object]"!
    // See HubSpot/I18n#209
    if (isObject(translation) && !this.isSet(options.count)) {
      translation = this.lookup(scope, I18n.prepareOptions({locale: this.defaultLocale}, options));
    }
    // END HACK

    if (translation === undefined || translation === null) {
      return this.missingTranslation(scope, options);
    }

    // HACK: Format count param if the translation is not an object
    if (!isObject(translation) && typeof options.count === 'number') {
      options.count = I18n.formatNumber(options.count);
    }
    // END HACK

    if (typeof(translation) === "string") {
      translation = this.interpolate(translation, options);
    // HACK, HubSpot fix
    // } else if (translation instanceof Object && this.isSet(options.count)) {
    } else if (isObject(translation) && this.isSet(options.count)) {
    // END HACK
      translation = this.pluralize(options.count, translation, options);
      // HACK: Fall back on default locale if pluralization failed
      if (translation === undefined && options.locale !== this.defaultLocale) {
        return I18n.translate(scope, I18n.prepareOptions({locale: this.defaultLocale}, options));
      }
      // END HACK
    }

    return translation;
  };

  // This function interpolates the all variables in the given message.
  I18n.interpolate = function(message, options) {
    options = this.prepareOptions(options);
    var matches = message.match(this.placeholder)
      , placeholder
      , value
      , name
      , regex
    ;

    if (!matches) {
      return message;
    }

    var value;

    while (matches.length) {
      placeholder = matches.shift();
      name = placeholder.replace(this.placeholder, "$1");

      if (this.isSet(options[name])) {
        value = options[name].toString().replace(/\$/gm, "_#$#_");
      } else if (name in options) {
        // HACK: Pass options through to nullPlaceholder/missingPlaceholder
        // value = this.nullPlaceholder(placeholder, message);
        value = this.nullPlaceholder(placeholder, message, options);
      } else {
        // value = this.missingPlaceholder(placeholder, message);
        value = this.missingPlaceholder(placeholder, message, options);
      }

      regex = new RegExp(placeholder.replace(/\{/gm, "\\{").replace(/\}/gm, "\\}"));
      message = message.replace(regex, value);
    }

    return message.replace(/_#\$#_/g, "$");
  };

  // Pluralize the given scope using the `count` value.
  // The pluralized translation may have other placeholders,
  // which will be retrieved from `options`.
  I18n.pluralize = function(count, scope, options) {
    options = this.prepareOptions(options);
    var translations, pluralizer, keys, key, message;

    // HACK, HubSpot fix
    // if (scope instanceof Object) {
    if (isObject(scope)) {
      translations = scope;
    // END HACK
    } else {
      translations = this.lookup(scope, options);
    }

    if (!translations) {
      return this.missingTranslation(scope, options);
    }

    pluralizer = this.pluralization.get(options.locale);
    keys = pluralizer(count);

    while (keys.length) {
      key = keys.shift();

      if (this.isSet(translations[key])) {
        message = translations[key];
        break;
      }
    }

    // HACK, if no translation keys matched then return instead of throwing an error (#303)
    if (typeof message !== 'string') {
      return undefined;
    }
    // END HACK

    // HACK, format count to a localized string instead of just casting it
    // options.count = String(count);
    if (typeof options.count === 'number') {
      options.count = I18n.formatNumber(count);
    }
    // END HACK

    return this.interpolate(message, options);
  };

  // Return a missing translation message for the given parameters.
  I18n.missingTranslation = function(scope, options) {
    //guess intended string
    if(this.missingBehaviour == 'guess'){
      //get only the last portion of the scope
      var s = scope.split('.').slice(-1)[0];
      //replace underscore with space && camelcase with space and lowercase letter
      return (this.missingTranslationPrefix.length > 0 ? this.missingTranslationPrefix : '') +
          s.replace('_',' ').replace(/([a-z])([A-Z])/g,
          function(match, p1, p2) {return p1 + ' ' + p2.toLowerCase()} );
    }

    var fullScope           = this.getFullScope(scope, options);
    var fullScopeWithLocale = [this.currentLocale(), fullScope].join(this.defaultSeparator);

    return '[missing “' + fullScopeWithLocale + '” translation]';
  };

  // Return a missing placeholder message for given parameters
  I18n.missingPlaceholder = function(placeholder, message) {
    return "[missing " + placeholder + " value]";
  };

  I18n.nullPlaceholder = function() {
    return I18n.missingPlaceholder.apply(I18n, arguments);
  };

  // Format number using localization rules.
  // The options will be retrieved from the `number.format` scope.
  // If this isn't present, then the following options will be used:
  //
  // - `precision`: `3`
  // - `separator`: `"."`
  // - `delimiter`: `","`
  // - `strip_insignificant_zeros`: `true`     // HACK, HubSpot customization to make this default to true instead of false (more info at https://git.hubteam.com/HubSpot/I18n/commit/32fdaf1abad25b3b937a2947a83d788603636841 and https://git.hubteam.com/HubSpot/I18n/commit/7cff88e13955e56cf0f373480f3b04e7fc8b0512)
  //
  // You can also override these options by providing the `options` argument.
  //
  I18n.toNumber = function(number, options) {
    options = this.prepareOptions(
        options
      , this.lookup("number.format")
      , NUMBER_FORMAT
    );

    var negative = number < 0
      , string = Math.abs(number).toFixed(options.precision).toString()
      , parts = string.split(".")
      , precision
      , buffer = []
      , formattedNumber
      , format = options.format || "%n"
      , sign = negative ? "−" : ""
    ;

    number = parts[0];
    precision = parts[1];

    while (number.length > 0) {
      buffer.unshift(number.substr(Math.max(0, number.length - 3), 3));
      number = number.substr(0, number.length -3);
    }

    formattedNumber = buffer.join(options.delimiter);

    if (options.strip_insignificant_zeros && precision) {
      precision = precision.replace(/0+$/, "");
    }

    if (options.precision > 0 && precision) {
      formattedNumber += options.separator + precision;
    }

    if (options.sign_first) {
      format = "%s" + format;
    }
    else {
      format = format.replace("%n", "%s%n");
    }

    formattedNumber = format
      .replace("%u", options.unit)
      .replace("%n", formattedNumber)
      .replace("%s", sign)
    ;

    return formattedNumber;
  };

  // Format currency with localization rules.
  // The options will be retrieved from the `number.currency.format` and
  // `number.format` scopes, in that order.
  //
  // Any missing option will be retrieved from the `I18n.toNumber` defaults and
  // the following options:
  //
  // - `unit`: `"$"`
  // - `precision`: `2`
  // - `format`: `"%u%n"`
  // - `delimiter`: `","`
  // - `separator`: `"."`
  //
  // You can also override these options by providing the `options` argument.
  //
  I18n.toCurrency = function(number, options) {
    var customLocale = (options || {}).locale;
    options = this.prepareOptions(
        options
      , this.lookup("number.currency.format", { locale: customLocale })
      , this.lookup("number.format", { locale: customLocale })
      , CURRENCY_FORMAT
    );

    return this.toNumber(number, options);
  };

  // Localize several values.
  // You can provide the following scopes: `currency`, `number`, or `percentage`.
  // If you provide a scope that matches the `/^(date|time)/` regular expression
  // then the `value` will be converted by using the `I18n.toTime` function.
  //
  // It will default to the value's `toString` function.
  //
  I18n.localize = function(scope, value, options) {
    options || (options = {});

    switch (scope) {
      case "currency":
        return this.toCurrency(value);
      case "number":
        scope = this.lookup("number.format");
        return this.toNumber(value, scope);
      case "percentage":
        return this.toPercentage(value);
      default:
        var localizedValue;

        if (scope.match(/^(date|time)/)) {
          localizedValue = this.toTime(scope, value);
        } else {
          localizedValue = value.toString();
        }

        return this.interpolate(localizedValue, options);
    }
  };


  // Parse a given `date` string into a JavaScript Date object.
  // This function is time zone aware.
  //
  // The following string formats are recognized:
  //
  //    yyyy-mm-dd
  //    yyyy-mm-dd[ T]hh:mm::ss
  //    yyyy-mm-dd[ T]hh:mm::ss
  //    yyyy-mm-dd[ T]hh:mm::ssZ
  //    yyyy-mm-dd[ T]hh:mm::ss+0000
  //    yyyy-mm-dd[ T]hh:mm::ss+00:00
  //    yyyy-mm-dd[ T]hh:mm::ss.123Z
  //
  I18n.parseDate = function(date) {
    var matches, convertedDate, fraction;
    // we have a date, so just return it.
    if (typeof(date) == "object") {
      return date;
    };

    matches = date.toString().match(/(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}):(\d{2})([\.,]\d{1,3})?)?(Z|\+00:?00)?/);

    if (matches) {
      for (var i = 1; i <= 6; i++) {
        matches[i] = parseInt(matches[i], 10) || 0;
      }

      // month starts on 0
      matches[2] -= 1;

      fraction = matches[7] ? 1000 * ("0" + matches[7]) : null;

      if (matches[8]) {
        convertedDate = new Date(Date.UTC(matches[1], matches[2], matches[3], matches[4], matches[5], matches[6], fraction));
      } else {
        convertedDate = new Date(matches[1], matches[2], matches[3], matches[4], matches[5], matches[6], fraction);
      }
    } else if (typeof(date) == "number") {
      // UNIX timestamp
      convertedDate = new Date();
      convertedDate.setTime(date);
    } else if (date.match(/([A-Z][a-z]{2}) ([A-Z][a-z]{2}) (\d+) (\d+:\d+:\d+) ([+-]\d+) (\d+)/)) {
      // This format `Wed Jul 20 13:03:39 +0000 2011` is parsed by
      // webkit/firefox, but not by IE, so we must parse it manually.
      convertedDate = new Date();
      convertedDate.setTime(Date.parse([
        RegExp.$1, RegExp.$2, RegExp.$3, RegExp.$6, RegExp.$4, RegExp.$5
      ].join(" ")));
    } else if (date.match(/\d+ \d+:\d+:\d+ [+-]\d+ \d+/)) {
      // a valid javascript format with timezone info
      convertedDate = new Date();
      convertedDate.setTime(Date.parse(date));
    } else {
      // an arbitrary javascript string
      convertedDate = new Date();
      convertedDate.setTime(Date.parse(date));
    }

    return convertedDate;
  };


  // Formats time according to the directives in the given format string.
  // The directives begins with a percent (%) character. Any text not listed as a
  // directive will be passed through to the output string.
  //
  // The accepted formats are:
  //
  //     %a  - The abbreviated weekday name (Sun)
  //     %A  - The full weekday name (Sunday)
  //     %b  - The abbreviated month name (Jan)
  //     %B  - The full month name (January)
  //     %c  - The preferred local date and time representation
  //     %d  - Day of the month (01..31)
  //     %-d - Day of the month (1..31)
  //     %H  - Hour of the day, 24-hour clock (00..23)
  //     %-H - Hour of the day, 24-hour clock (0..23)
  //     %I  - Hour of the day, 12-hour clock (01..12)
  //     %-I - Hour of the day, 12-hour clock (1..12)
  //     %m  - Month of the year (01..12)
  //     %-m - Month of the year (1..12)
  //     %M  - Minute of the hour (00..59)
  //     %-M - Minute of the hour (0..59)
  //     %p  - Meridian indicator (AM  or  PM)
  //     %S  - Second of the minute (00..60)
  //     %-S - Second of the minute (0..60)
  //     %w  - Day of the week (Sunday is 0, 0..6)
  //     %y  - Year without a century (00..99)
  //     %-y - Year without a century (0..99)
  //     %Y  - Year with century
  //     %z  - Timezone offset (+0545)
  //
  I18n.strftime = function(date, format) {
    var options = this.lookup("date")
      , meridianOptions = I18n.meridian()
    ;

    if (!options) {
      options = {};
    }

    options = this.prepareOptions(options, DATE);

    var weekDay = date.getDay()
      , day = date.getDate()
      , year = date.getFullYear()
      , month = date.getMonth() + 1
      , hour = date.getHours()
      , hour12 = hour
      , meridian = hour > 11 ? 1 : 0
      , secs = date.getSeconds()
      , mins = date.getMinutes()
      , offset = date.getTimezoneOffset()
      , absOffsetHours = Math.floor(Math.abs(offset / 60))
      , absOffsetMinutes = Math.abs(offset) - (absOffsetHours * 60)
      , timezoneoffset = (offset > 0 ? "-" : "+") +
          (absOffsetHours.toString().length < 2 ? "0" + absOffsetHours : absOffsetHours) +
          (absOffsetMinutes.toString().length < 2 ? "0" + absOffsetMinutes : absOffsetMinutes)
    ;

    if (hour12 > 12) {
      hour12 = hour12 - 12;
    } else if (hour12 === 0) {
      hour12 = 12;
    }

    format = format.replace("%a", options.abbr_day_names[weekDay]);
    format = format.replace("%A", options.day_names[weekDay]);
    format = format.replace("%b", options.abbr_month_names[month]);
    format = format.replace("%B", options.month_names[month]);
    format = format.replace("%d", padding(day));
    format = format.replace("%e", day);
    format = format.replace("%-d", day);
    format = format.replace("%H", padding(hour));
    format = format.replace("%-H", hour);
    format = format.replace("%I", padding(hour12));
    format = format.replace("%-I", hour12);
    format = format.replace("%m", padding(month));
    format = format.replace("%-m", month);
    format = format.replace("%M", padding(mins));
    format = format.replace("%-M", mins);
    format = format.replace("%p", meridianOptions[meridian]);
    format = format.replace("%S", padding(secs));
    format = format.replace("%-S", secs);
    format = format.replace("%w", weekDay);
    format = format.replace("%y", padding(year));
    format = format.replace("%-y", padding(year).replace(/^0+/, ""));
    format = format.replace("%Y", year);
    format = format.replace("%z", timezoneoffset);

    return format;
  };

  // Convert the given dateString into a formatted date.
  I18n.toTime = function(scope, dateString) {
    var date = this.parseDate(dateString)
      , format = this.lookup(scope)
    ;

    if (date.toString().match(/invalid/i)) {
      return date.toString();
    }

    if (!format) {
      return date.toString();
    }

    return this.strftime(date, format);
  };

  // Convert a number into a formatted percentage value.
  I18n.toPercentage = function(number, options) {
    options = this.prepareOptions(
        options
      , this.lookup("number.percentage.format")
      , this.lookup("number.format")
      , PERCENTAGE_FORMAT
    );

    return this.toNumber(number, options);
  };

  // Convert a number into a readable size representation.
  I18n.toHumanSize = function(number, options) {
    var kb = 1024
      , size = number
      , iterations = 0
      , unit
      , precision
    ;

    while (size >= kb && iterations < 4) {
      size = size / kb;
      iterations += 1;
    }

    if (iterations === 0) {
      unit = this.t("number.human.storage_units.units.byte", {count: size});
      precision = 0;
    } else {
      unit = this.t("number.human.storage_units.units." + SIZE_UNITS[iterations]);
      precision = (size - Math.floor(size) === 0) ? 0 : 1;
    }

    options = this.prepareOptions(
        options
      , {unit: unit, precision: precision, format: "%n%u", delimiter: ""}
    );

    return this.toNumber(size, options);
  };

  I18n.getFullScope = function(scope, options) {
    options = this.prepareOptions(options);

    // Deal with the scope as an array.
    if (scope.constructor === Array) {
      scope = scope.join(this.defaultSeparator);
    }

    // Deal with the scope option provided through the second argument.
    //
    //    I18n.t('hello', {scope: 'greetings'});
    //
    if (options.scope) {
      scope = [options.scope, scope].join(this.defaultSeparator);
    }

    return scope;
  }

  // Set aliases, so we can save some typing.
  I18n.t = I18n.translate;
  I18n.l = I18n.localize;
  I18n.p = I18n.pluralize;

  // HACK, export default formats for use in our methods
  I18n.NUMBER_FORMAT = NUMBER_FORMAT;
  I18n.CURRENCY_FORMAT = CURRENCY_FORMAT;
  I18n.PERCENTAGE_FORMAT = PERCENTAGE_FORMAT;

// HACK, HubSpot customization so that the config can be set before the library is loaded.
// (more info at https://git.hubteam.com/HubSpot/I18n/commit/4187783fba78f9249817e16487bc0c28fa3f0557)
// })(typeof(exports) === "undefined" ? (this.I18n = {}) : exports);
})(window.I18n = window.I18n || {});
// END HACK


(function () {
var slice = [].slice;

I18n.debugLog = function() {
  var args, enabled;
  args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  if (typeof document === "undefined" || document === null) {
    return;
  }
  enabled = this.I18N_DEBUG_LOG || window.I18N_DEBUG;
  try {
    enabled || (enabled = localStorage.I18N_DEBUG_LOG === "true" || localStorage.I18N_DEBUG === "true");
  } catch (undefined) {}
  if (enabled !== true) {
    return;
  }
  args.unshift('I18n:');
  if (window.parent !== window) {
    args.unshift('(IFRAME)');
  }
  return typeof console !== "undefined" && console !== null ? typeof console.log === "function" ? console.log.apply(console, args) : void 0 : void 0;
};

I18n.onAnyTrigger = function() {
  var args, eventName;
  eventName = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
  return I18n.debugLog.apply(I18n, ["triggered " + eventName].concat(slice.call(args)));
};
}());

(function(I18n) {
  // SafeString type to be used to mark I18n params as _not_ needing escaping.
  // (concept borrowed from http://handlebarsjs.com/#html-escaping)
  function SafeString(string) {
    // Work even if called without `new`
    if (!(this instanceof SafeString)) {
      return new SafeString(string);
    } else {
      this.string = string;
    }
  }

  SafeString.prototype.toString = SafeString.prototype.toHTML = function() {
    return '' + this.string;
  };

  I18n.SafeString = SafeString;
})(I18n);


(function () {
I18n.whenDOMContentLoaded = function(callback) {
  var ref;
  if ((ref = document.readyState) === 'interactive' || ref === 'complete') {
    setTimeout(callback, 1);
  } else {
    document.addEventListener('DOMContentLoaded', callback, false);
  }
};
}());

// Stolen (and cleaned up/tweaked) from the Intl.NumberFormat Spec:
// http://www.ecma-international.org/ecma-402/1.0/#ToRawFixed
(function(I18n) {
  var arrJoin = Array.prototype.join;

  function toRawFixed(
    x,
    minIntegerDigits,
    minFractionDigits,
    maxFractionDigits
  ) {
    var idx,
      result = Number.prototype.toFixed.call(x, maxFractionDigits),
      intDigits = result.split('.')[0].length,
      cut = maxFractionDigits - minFractionDigits,
      exp = (idx = result.indexOf('e')) > -1 ? result.slice(idx + 1) : 0;

    if (exp) {
      result = result.slice(0, idx).replace('.', '');
      result +=
        arrJoin.call(Array(exp - (result.length - 1) + 1), '0') +
        '.' +
        arrJoin.call(Array(maxFractionDigits + 1), '0');

      intDigits = result.length;
    }

    // Repeat while cut > 0 and the last character of result is "0":
    while (cut > 0 && result.slice(-1) === '0') {
      result = result.slice(0, -1);
      cut--;
    }

    // If the last character of result is ".", then remove it
    if (result.slice(-1) === '.') result = result.slice(0, -1);

    // If int < minIntegerDigits, then pad front with zeros
    if (intDigits < minIntegerDigits)
      var padding = arrJoin.call(Array(minIntegerDigits - intDigits + 1), '0');

    return (padding ? padding : '') + result;
  }

  I18n.util = I18n.util || {};
  I18n.util.toRawFixed = toRawFixed;
})(I18n);


// Stolen (and cleaned up/tweaked) from the Intl.NumberFormat Spec:
// http://www.ecma-international.org/ecma-402/1.0/#ToRawPrecision
(function(I18n) {
  var arrJoin = Array.prototype.join;

  // A function to deal with the inaccuracy of calculating log10 in pre-ES6
  // JavaScript environments. Math.log(num) / Math.LN10 was responsible for
  // causing issue #62.
  function log10Floor(n) {
    // ES6 provides the more accurate Math.log10
    if (typeof Math.log10 === 'function') {
      return Math.floor(Math.log10(n));
    }

    var x = Math.round(Math.log(n) * Math.LOG10E);
    return x - (Number('1e' + x) > n);
  }

  function toRawPrecision(x, minPrecision, maxPrecision) {
    var result,
      numDigits,
      isNegative = x < 0;

    // Deal with negative values later
    x = Math.abs(x);

    // If 0, pad out to maxPrecision 0 characters
    if (x === 0) {
      result = arrJoin.call(Array(maxPrecision + 1), '0');
      numDigits = 1;
    } else {
      // Positive values mean # of int digits and negative values mean # of fractional digits
      numDigits = log10Floor(Math.abs(x)) + 1;

      // Easier to get to result from here
      var factor = Math.round(
        Math.exp(Math.abs(numDigits - maxPrecision) * Math.LN10)
      );

      // b. Let result be the String consisting of the digits of the decimal
      //  representation of n (in order, with no leading zeroes)
      result = String(
        Math.round(numDigits - maxPrecision < 0 ? x * factor : x / factor)
      );
    }

    // If numDigits ≥ maxPrecision, then pad the end of the number with zeros
    if (numDigits > maxPrecision) {
      result = result + arrJoin.call(Array(numDigits - maxPrecision + 1), '0');
      return isNegative ? '-' + result : result;

      // If numDigits = maxPrecision, then don't need to do anything
    } else if (numDigits === maxPrecision) {
      return isNegative ? '-' + result : result;

      // If numDigits > 0, then format as a decimal number with maxPrecision total digits
    } else if (numDigits > 0) {
      //var cutPoint = isNegative ? numDigits : numDigits + 1;
      result = result.slice(0, numDigits) + '.' + result.slice(numDigits);

      // If numDigits <= 0, then pad 0 zeros in front of decimal as needed
    } else if (numDigits <= 0) {
      result = '0.' + arrJoin.call(Array(-numDigits + 1), '0') + result;
    }

    // If result contains the character ".", and maxPrecision > minPrecision, then
    if (result.indexOf('.') >= 0 && maxPrecision > minPrecision) {
      var cut = maxPrecision - minPrecision;

      // Repeat while cut > 0 and the last character of result is "0":
      while (cut > 0 && result.charAt(result.length - 1) === '0') {
        result = result.slice(0, -1);
        cut--;
      }

      // If the last character of result is ".", then remove it
      if (result.charAt(result.length - 1) === '.')
        result = result.slice(0, -1);
    }

    return isNegative ? '-' + result : result;
  }

  I18n.util = I18n.util || {};
  I18n.util.log10Floor = log10Floor;
  I18n.util.toRawPrecision = toRawPrecision;
})(I18n);


(function () {
var Evented, k, ref, v,
  slice = [].slice;

Evented = (function() {
  function Evented() {}

  Evented.prototype.on = function(event, handler, ctx, once) {
    var base, e, j, len, ref, results;
    if (once == null) {
      once = false;
    }
    if (event.indexOf(' ') !== -1) {
      ref = event.split(' ');
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        e = ref[j];
        results.push(this.on(e, handler, ctx, once));
      }
      return results;
    } else {
      if (this.bindings == null) {
        this.bindings = {};
      }
      if ((base = this.bindings)[event] == null) {
        base[event] = [];
      }
      return this.bindings[event].push({
        handler: handler,
        ctx: ctx,
        once: once
      });
    }
  };

  Evented.prototype.once = function(event, handler, ctx) {
    return this.on(event, handler, ctx, true);
  };

  Evented.prototype.off = function(event, handler) {
    var i, ref, results;
    if (((ref = this.bindings) != null ? ref[event] : void 0) == null) {
      return;
    }
    if (handler == null) {
      return delete this.bindings[event];
    } else {
      i = 0;
      results = [];
      while (i < this.bindings[event].length) {
        if (this.bindings[event][i].handler === handler) {
          results.push(this.bindings[event].splice(i, 1));
        } else {
          results.push(i++);
        }
      }
      return results;
    }
  };

  Evented.prototype.when = function(event, handler, ctx) {
    var e, j, len, ref, ref1;
    if (event.indexOf(' ') !== -1) {
      ref = event.split(' ');
      for (j = 0, len = ref.length; j < len; j++) {
        e = ref[j];
        this.when(e, handler, ctx);
      }
      return;
    }
    if ((ref1 = this.fired) != null ? ref1[event] : void 0) {
      return handler.call(ctx != null ? ctx : this);
    } else {
      return this.once(event, handler, ctx);
    }
  };

  Evented.prototype.trigger = function() {
    var args, ctx, event, handler, i, once, ref, ref1, results;
    event = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
    if (this.fired == null) {
      this.fired = {};
    }
    this.fired[event] = true;
    if (typeof this.onAnyTrigger === "function") {
      this.onAnyTrigger.apply(this, [event].concat(slice.call(args)));
    }
    if ((ref = this.bindings) != null ? ref[event] : void 0) {
      i = 0;
      results = [];
      while (i < this.bindings[event].length) {
        ref1 = this.bindings[event][i], handler = ref1.handler, ctx = ref1.ctx, once = ref1.once;
        if (once) {
          this.bindings[event].splice(i, 1);
        } else {
          i++;
        }
        results.push(handler.apply(ctx != null ? ctx : this, args));
      }
      return results;
    }
  };

  return Evented;

})();

if ((typeof window !== "undefined" && window !== null) && !window.isServer) {
  ref = Evented.prototype;
  for (k in ref) {
    v = ref[k];
    window.I18n[k] = v;
  }
}
}());

(function () {
var init, ref;

init = function(moment) {
  I18n.isLegacyLoader = true;
  I18n.moment = moment;
  if (typeof I18n.trigger === "function") {
    I18n.trigger('moment:init');
  }
  I18n.fallbacks = true;
  if (I18n.translationsLoaded == null) {
    I18n.translationsLoaded = {};
  }
  if (I18n.moment.locale != null) {
    return I18n.moment.locale(I18n.locale);
  } else {
    return I18n.moment.lang(I18n.locale);
  }
};

init(window.moment);

if (I18n.translations == null) {
  I18n.translations = {};
}

if (typeof window !== "undefined" && window !== null ? (ref = window.I18n) != null ? ref.loaded : void 0 : void 0) {
  console.error("I18n/init.js brought in more than once");
}

I18n.loaded = true;
}());

(function () {
var Promise;

Promise = (function() {
  function Promise() {
    this.cbs = [];
  }

  Promise.prototype.then = function(yep, nope) {
    switch (this.state) {
      case 'resolved':
        return typeof yep === "function" ? yep(this.value) : void 0;
      case 'rejected':
        return typeof nope === "function" ? nope(this.value) : void 0;
      default:
        return this.cbs.push([yep, nope]);
    }
  };

  Promise.prototype.resolve = function(value) {
    this.value = value;
    this.state = 'resolved';
    return this._run();
  };

  Promise.prototype.reject = function(value) {
    this.value = value;
    this.state = 'rejected';
    return this._run();
  };

  Promise.prototype._run = function() {
    var cbs, i, len, ref;
    if (this.cbs == null) {
      return;
    }
    ref = this.cbs;
    for (i = 0, len = ref.length; i < len; i++) {
      cbs = ref[i];
      this.then.apply(this, cbs);
    }
    return this.cbs = null;
  };

  Promise.prototype.done = Promise.prototype.then;

  return Promise;

})();

I18n.Locale = new Promise;

I18n.when('locale:ready', function() {
  return I18n.Locale.resolve(I18n);
});

I18n.Timezone = new Promise;

I18n.when('timezone:ready', function() {
  return I18n.Timezone.resolve(I18n);
});

I18n.Info = new Promise;

I18n.when('ready', function() {
  var i18nDuration, i18nLangLocale, ref, ref1;
  I18n.Info.resolve(I18n);
  try {
    window.performance.mark('mark_i18n_load_successful');
    window.performance.measure('measure_i18n_load_time', void 0, 'mark_i18n_load_successful');
    if (i18nDuration = window.performance.getEntriesByName('measure_i18n_load_time')[0].duration) {
      if ((ref = window.newrelic) != null) {
        ref.setCustomAttribute('i18nTime', i18nDuration);
      }
    }
    i18nLangLocale = I18n.locale !== 'en-us' && !I18n.langEnabled && !I18n.publicPage ? 'en-us' : I18n.locale;
    return (ref1 = window.newrelic) != null ? ref1.setCustomAttribute('i18nLangLocale', i18nLangLocale) : void 0;
  } catch (undefined) {}
});

I18n.Promise = Promise;
}());

hns('I18n.countries', {});

hns('I18n.translations.bn', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u %n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 2,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": "Byte",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      }
    }
  }
});

hns('I18n.translations.cs', {
  "number": {
    "currency": {
      "format": {
        "delimiter": " ",
        "format": "%u%n",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      }
    },
    "format": {
      "delimiter": " ",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": " ",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "B",
            "few": "B",
            "other": "B"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      }
    }
  }
});

hns('I18n.translations.da', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%u%n",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ".",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      }
    }
  }
});

hns('I18n.translations.de', {
  "number": {
    "format": {
      "precision": 3,
      "separator": ",",
      "delimiter": ".",
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "precision": 0
      }
    },
    "currency": {
      "format": {
        "strip_insignificant_zeros": false,
        "unit": "€",
        "precision": 2,
        "format": "%n %u",
        "delimiter": ".",
        "separator": ","
      }
    },
    "human": {
      "storage_units": {
        "units": {
          "byte": " Byte",
          "kb": "kb",
          "mb": "mb",
          "gb": "gb",
          "tb": "tb"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " und ",
          "lastWordConnector": " und "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " oder ",
          "lastWordConnector": " oder "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 Tausend",
            "other": "0 Tausend"
          },
          "10000": {
            "one": "00 Tausend",
            "other": "00 Tausend"
          },
          "100000": {
            "one": "000 Tausend",
            "other": "000 Tausend"
          },
          "1000000": {
            "one": "0 Million",
            "other": "0 Millionen"
          },
          "10000000": {
            "one": "00 Millionen",
            "other": "00 Millionen"
          },
          "100000000": {
            "one": "000 Millionen",
            "other": "000 Millionen"
          },
          "1000000000": {
            "one": "0 Milliarde",
            "other": "0 Milliarden"
          },
          "10000000000": {
            "one": "00 Milliarden",
            "other": "00 Milliarden"
          },
          "100000000000": {
            "one": "000 Milliarden",
            "other": "000 Milliarden"
          },
          "1000000000000": {
            "one": "0 Billion",
            "other": "0 Billionen"
          },
          "10000000000000": {
            "one": "00 Billionen",
            "other": "00 Billionen"
          },
          "100000000000000": {
            "one": "000 Billionen",
            "other": "000 Billionen"
          }
        },
        "short": {
          "1000": {
            "one": "0 Tsd.",
            "other": "0 Tsd."
          },
          "10000": {
            "one": "00 Tsd.",
            "other": "00 Tsd."
          },
          "100000": {
            "one": "000 Tsd.",
            "other": "000 Tsd."
          },
          "1000000": {
            "one": "0 Mio",
            "other": "0 Mio"
          },
          "10000000": {
            "one": "00 Mio",
            "other": "00 Mio"
          },
          "100000000": {
            "one": "000 Mio",
            "other": "000 Mio"
          },
          "1000000000": {
            "one": "0 Mrd",
            "other": "0 Mrd"
          },
          "10000000000": {
            "one": "00 Mrd",
            "other": "00 Mrd"
          },
          "100000000000": {
            "one": "000 Mrd",
            "other": "000 Mrd"
          },
          "1000000000000": {
            "one": "0 Bio.",
            "other": "0 Bio."
          },
          "10000000000000": {
            "one": "00 Bio.",
            "other": "00 Bio."
          },
          "100000000000000": {
            "one": "000 Bio.",
            "other": "000 Bio."
          }
        }
      }
    }
  }
});

hns('I18n.translations.el', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%u%n",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ".",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      }
    }
  }
});

hns('I18n.translations.en-au', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " and ",
          "lastWordConnector": ", and "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " or ",
          "lastWordConnector": ", or "
        }
      }
    }
  }
});

hns('I18n.translations.en-ca', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " and ",
          "lastWordConnector": ", and "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " or ",
          "lastWordConnector": ", or "
        }
      }
    }
  }
});

hns('I18n.translations.en-gb', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "£"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " and ",
          "lastWordConnector": ", and "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " or ",
          "lastWordConnector": ", or "
        }
      }
    }
  }
});

hns('I18n.translations.en-ie', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " and ",
          "lastWordConnector": ", and "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " or ",
          "lastWordConnector": ", or "
        }
      }
    }
  }
});

hns('I18n.translations.en-in', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "₹"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " and ",
          "lastWordConnector": ", and "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " or ",
          "lastWordConnector": ", or "
        }
      }
    }
  }
});

hns('I18n.translations.en-nz', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " and ",
          "lastWordConnector": ", and "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " or ",
          "lastWordConnector": ", or "
        }
      }
    }
  }
});

hns('I18n.translations.en-us', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ",",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " and ",
          "lastWordConnector": ", and "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " or ",
          "lastWordConnector": ", or "
        }
      }
    }
  }
});

hns('I18n.translations.en', {
  "number": {
    "format": {
      "precision": 3,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ",",
        "format": "%n%",
        "precision": 0
      }
    },
    "currency": {
      "format": {
        "precision": 2,
        "strip_insignificant_zeros": false
      }
    },
    "human": {
      "storage_units": {
        "units": {
          "byte": {
            "one": " byte",
            "other": " bytes"
          },
          "kb": "kb",
          "mb": "mb",
          "gb": "gb",
          "tb": "tb"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " and ",
          "lastWordConnector": ", and "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " or ",
          "lastWordConnector": ", or "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 thousand",
            "other": "0 thousand"
          },
          "10000": {
            "one": "00 thousand",
            "other": "00 thousand"
          },
          "100000": {
            "one": "000 thousand",
            "other": "000 thousand"
          },
          "1000000": {
            "one": "0 million",
            "other": "0 million"
          },
          "10000000": {
            "one": "00 million",
            "other": "00 million"
          },
          "100000000": {
            "one": "000 million",
            "other": "000 million"
          },
          "1000000000": {
            "one": "0 billion",
            "other": "0 billion"
          },
          "10000000000": {
            "one": "00 billion",
            "other": "00 billion"
          },
          "100000000000": {
            "one": "000 billion",
            "other": "000 billion"
          },
          "1000000000000": {
            "one": "0 trillion",
            "other": "0 trillion"
          },
          "10000000000000": {
            "one": "00 trillion",
            "other": "00 trillion"
          },
          "100000000000000": {
            "one": "000 trillion",
            "other": "000 trillion"
          }
        },
        "short": {
          "1000": {
            "one": "0K",
            "other": "0K"
          },
          "10000": {
            "one": "00K",
            "other": "00K"
          },
          "100000": {
            "one": "000K",
            "other": "000K"
          },
          "1000000": {
            "one": "0M",
            "other": "0M"
          },
          "10000000": {
            "one": "00M",
            "other": "00M"
          },
          "100000000": {
            "one": "000M",
            "other": "000M"
          },
          "1000000000": {
            "one": "0B",
            "other": "0B"
          },
          "10000000000": {
            "one": "00B",
            "other": "00B"
          },
          "100000000000": {
            "one": "000B",
            "other": "000B"
          },
          "1000000000000": {
            "one": "0T",
            "other": "0T"
          },
          "10000000000000": {
            "one": "00T",
            "other": "00T"
          },
          "100000000000000": {
            "one": "000T",
            "other": "000T"
          }
        }
      }
    }
  }
});

hns('I18n.translations.es-ar', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%u%n",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "separator": ",",
      "significant": true,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ",",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " y ",
          "lastWordConnector": " y "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " o ",
          "lastWordConnector": ", o "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 mil",
            "other": "0 mil"
          },
          "10000": {
            "one": "00 mil",
            "other": "00 mil"
          },
          "100000": {
            "one": "000 mil",
            "other": "000 mil"
          },
          "1000000": {
            "one": "0 millón",
            "other": "0 millones"
          },
          "10000000": {
            "one": "00 millones",
            "other": "00 millones"
          },
          "100000000": {
            "one": "000 millones",
            "other": "000 millones"
          },
          "1000000000": {
            "one": "0 mil millones",
            "other": "0 mil millones"
          },
          "10000000000": {
            "one": "00 mil millones",
            "other": "00 mil millones"
          },
          "100000000000": {
            "one": "000 mil millones",
            "other": "000 mil millones"
          },
          "1000000000000": {
            "one": "0 billón",
            "other": "0 billones"
          },
          "10000000000000": {
            "one": "00 billones",
            "other": "00 billones"
          },
          "100000000000000": {
            "one": "000 billones",
            "other": "000 billones"
          }
        },
        "short": {
          "1000": {
            "one": "0K",
            "other": "0K"
          },
          "10000": {
            "one": "00K",
            "other": "00K"
          },
          "100000": {
            "one": "000K",
            "other": "000K"
          },
          "1000000": {
            "one": "0MM",
            "other": "0MM"
          },
          "10000000": {
            "one": "00MM",
            "other": "00MM"
          },
          "100000000": {
            "one": "000MM",
            "other": "000MM"
          },
          "1000000000": {
            "one": "0000MM",
            "other": "0000MM"
          },
          "10000000000": {
            "one": "00MRD",
            "other": "00MRD"
          },
          "100000000000": {
            "one": "000MRD",
            "other": "000MRD"
          },
          "1000000000000": {
            "one": "0B",
            "other": "0B"
          },
          "10000000000000": {
            "one": "00B",
            "other": "00B"
          },
          "100000000000000": {
            "one": "000B",
            "other": "000B"
          }
        }
      }
    }
  }
});

hns('I18n.translations.es-mx', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ",",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " y ",
          "lastWordConnector": " y "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " o ",
          "lastWordConnector": ", o "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 mil",
            "other": "0 mil"
          },
          "10000": {
            "one": "00 mil",
            "other": "00 mil"
          },
          "100000": {
            "one": "000 mil",
            "other": "000 mil"
          },
          "1000000": {
            "one": "0 millón",
            "other": "0 millones"
          },
          "10000000": {
            "one": "00 millones",
            "other": "00 millones"
          },
          "100000000": {
            "one": "000 millones",
            "other": "000 millones"
          },
          "1000000000": {
            "one": "0 mil millones",
            "other": "0 mil millones"
          },
          "10000000000": {
            "one": "00 mil millones",
            "other": "00 mil millones"
          },
          "100000000000": {
            "one": "000 mil millones",
            "other": "000 mil millones"
          },
          "1000000000000": {
            "one": "0 billón",
            "other": "0 billones"
          },
          "10000000000000": {
            "one": "00 billones",
            "other": "00 billones"
          },
          "100000000000000": {
            "one": "000 billones",
            "other": "000 billones"
          }
        },
        "short": {
          "1000": {
            "one": "0K",
            "other": "0K"
          },
          "10000": {
            "one": "00K",
            "other": "00K"
          },
          "100000": {
            "one": "000K",
            "other": "000K"
          },
          "1000000": {
            "one": "0M",
            "other": "0M"
          },
          "10000000": {
            "one": "00M",
            "other": "00M"
          },
          "100000000": {
            "one": "000M",
            "other": "000M"
          },
          "1000000000": {
            "one": "0000M",
            "other": "0000M"
          },
          "10000000000": {
            "one": "00MRD",
            "other": "00MRD"
          },
          "100000000000": {
            "one": "000MRD",
            "other": "000MRD"
          },
          "1000000000000": {
            "one": "0B",
            "other": "0B"
          },
          "10000000000000": {
            "one": "00B",
            "other": "00B"
          },
          "100000000000000": {
            "one": "000B",
            "other": "000B"
          }
        }
      }
    }
  }
});

hns('I18n.translations.es', {
  "number": {
    "format": {
      "precision": 3,
      "separator": ",",
      "delimiter": ".",
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "precision": 0
      }
    },
    "currency": {
      "format": {
        "strip_insignificant_zeros": false,
        "unit": "$",
        "precision": 2,
        "format": "%n %u",
        "delimiter": ".",
        "separator": ","
      }
    },
    "human": {
      "storage_units": {
        "units": {
          "byte": " Byte",
          "kb": "kb",
          "mb": "mb",
          "gb": "gb",
          "tb": "tb"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " y ",
          "lastWordConnector": ", y "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " o ",
          "lastWordConnector": ", o "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 mil",
            "other": "0 mil"
          },
          "10000": {
            "one": "00 mil",
            "other": "00 mil"
          },
          "100000": {
            "one": "000 mil",
            "other": "000 mil"
          },
          "1000000": {
            "one": "0 millón",
            "other": "0 millones"
          },
          "10000000": {
            "one": "00 millones",
            "other": "00 millones"
          },
          "100000000": {
            "one": "000 millones",
            "other": "000 millones"
          },
          "1000000000": {
            "one": "0 mil millones",
            "other": "0 mil millones"
          },
          "10000000000": {
            "one": "00 mil millones",
            "other": "00 mil millones"
          },
          "100000000000": {
            "one": "000 mil millones",
            "other": "000 mil millones"
          },
          "1000000000000": {
            "one": "0 billón",
            "other": "0 billones"
          },
          "10000000000000": {
            "one": "00 billones",
            "other": "00 billones"
          },
          "100000000000000": {
            "one": "000 billones",
            "other": "000 billones"
          }
        },
        "short": {
          "1000": {
            "one": "0K",
            "other": "0K"
          },
          "10000": {
            "one": "00K",
            "other": "00K"
          },
          "100000": {
            "one": "000K",
            "other": "000K"
          },
          "1000000": {
            "one": "0M",
            "other": "0M"
          },
          "10000000": {
            "one": "00M",
            "other": "00M"
          },
          "100000000": {
            "one": "000M",
            "other": "000M"
          },
          "1000000000": {
            "one": "0000M",
            "other": "0000M"
          },
          "10000000000": {
            "one": "00MRD",
            "other": "00MRD"
          },
          "100000000000": {
            "one": "000MRD",
            "other": "000MRD"
          },
          "1000000000000": {
            "one": "0B",
            "other": "0B"
          },
          "10000000000000": {
            "one": "00B",
            "other": "00B"
          },
          "100000000000000": {
            "one": "000B",
            "other": "000B"
          }
        }
      }
    }
  }
});

hns('I18n.translations.fi', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "tavu",
            "other": "tavua"
          },
          "gb": "GB",
          "kb": "kB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " ja ",
          "lastWordConnector": " ja "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " tai ",
          "lastWordConnector": " tai "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 tuhat",
            "other": "0 tuhatta"
          },
          "10000": {
            "one": "00 tuhatta",
            "other": "00 tuhatta"
          },
          "100000": {
            "one": "000 tuhatta",
            "other": "000 tuhatta"
          },
          "1000000": {
            "one": "0 miljoona",
            "other": "0 miljoonaa"
          },
          "10000000": {
            "one": "00 miljoonaa",
            "other": "00 miljoonaa"
          },
          "100000000": {
            "one": "000 miljoonaa",
            "other": "000 miljoonaa"
          },
          "1000000000": {
            "one": "0 miljardi",
            "other": "0 miljardia"
          },
          "10000000000": {
            "one": "00 miljardia",
            "other": "00 miljardia"
          },
          "100000000000": {
            "one": "000 miljardia",
            "other": "000 miljardia"
          },
          "1000000000000": {
            "one": "0 biljoona",
            "other": "0 biljoonaa"
          },
          "10000000000000": {
            "one": "00 biljoonaa",
            "other": "00 biljoonaa"
          },
          "100000000000000": {
            "one": "000 biljoonaa",
            "other": "000 biljoonaa"
          }
        },
        "short": {
          "1000": {
            "one": "0 t.",
            "other": "0 t."
          },
          "10000": {
            "one": "00 t.",
            "other": "00 t."
          },
          "100000": {
            "one": "000 t.",
            "other": "000 t."
          },
          "1000000": {
            "one": "0 milj.",
            "other": "0 milj."
          },
          "10000000": {
            "one": "00 milj.",
            "other": "00 milj."
          },
          "100000000": {
            "one": "000 milj.",
            "other": "000 milj."
          },
          "1000000000": {
            "one": "0 mrd.",
            "other": "0 mrd."
          },
          "10000000000": {
            "one": "00 mrd.",
            "other": "00 mrd."
          },
          "100000000000": {
            "one": "000 mrd.",
            "other": "000 mrd."
          },
          "1000000000000": {
            "one": "0 bilj.",
            "other": "0 bilj."
          },
          "10000000000000": {
            "one": "00 bilj.",
            "other": "00 bilj."
          },
          "100000000000000": {
            "one": "000 bilj.",
            "other": "000 bilj."
          }
        }
      }
    }
  }
});

hns('I18n.translations.fr-ca', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "octet",
            "other": "octets"
          },
          "gb": "Go",
          "kb": "ko",
          "mb": "Mo",
          "tb": "To"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " et ",
          "lastWordConnector": " et "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " ou ",
          "lastWordConnector": " ou "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 millier",
            "other": "0 mille"
          },
          "10000": {
            "one": "00 millier",
            "other": "00 mille"
          },
          "100000": {
            "one": "000 millier",
            "other": "000 mille"
          },
          "1000000": {
            "one": "0 million",
            "other": "0 millions"
          },
          "10000000": {
            "one": "00 million",
            "other": "00 millions"
          },
          "100000000": {
            "one": "000 million",
            "other": "000 millions"
          },
          "1000000000": {
            "one": "0 milliard",
            "other": "0 milliards"
          },
          "10000000000": {
            "one": "00 milliard",
            "other": "00 milliards"
          },
          "100000000000": {
            "one": "000 milliards",
            "other": "000 milliards"
          },
          "1000000000000": {
            "one": "0 billion",
            "other": "0 billions"
          },
          "10000000000000": {
            "one": "00 billions",
            "other": "00 billions"
          },
          "100000000000000": {
            "one": "000 billions",
            "other": "000 billions"
          }
        },
        "short": {
          "1000": {
            "one": "0 k",
            "other": "0 k"
          },
          "10000": {
            "one": "00 k",
            "other": "00 k"
          },
          "100000": {
            "one": "000 k",
            "other": "000 k"
          },
          "1000000": {
            "one": "0 M",
            "other": "0 M"
          },
          "10000000": {
            "one": "00 M",
            "other": "00 M"
          },
          "100000000": {
            "one": "000 M",
            "other": "000 M"
          },
          "1000000000": {
            "one": "0 Md",
            "other": "0 Md"
          },
          "10000000000": {
            "one": "00 Md",
            "other": "00 Md"
          },
          "100000000000": {
            "one": "000 Md",
            "other": "000 Md"
          },
          "1000000000000": {
            "one": "0 Bn",
            "other": "0 Bn"
          },
          "10000000000000": {
            "one": "00 Bn",
            "other": "00 Bn"
          },
          "100000000000000": {
            "one": "000 Bn",
            "other": "000 Bn"
          }
        }
      }
    }
  }
});

hns('I18n.translations.fr', {
  "number": {
    "currency": {
      "format": {
        "delimiter": " ",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": " ",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "octet",
            "other": "octets"
          },
          "gb": "Go",
          "kb": "ko",
          "mb": "Mo",
          "tb": "To"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " et ",
          "lastWordConnector": " et "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " ou ",
          "lastWordConnector": " ou "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 millier",
            "other": "0 mille"
          },
          "10000": {
            "one": "00 millier",
            "other": "00 mille"
          },
          "100000": {
            "one": "000 millier",
            "other": "000 mille"
          },
          "1000000": {
            "one": "0 million",
            "other": "0 millions"
          },
          "10000000": {
            "one": "00 million",
            "other": "00 millions"
          },
          "100000000": {
            "one": "000 million",
            "other": "000 millions"
          },
          "1000000000": {
            "one": "0 milliard",
            "other": "0 milliards"
          },
          "10000000000": {
            "one": "00 milliard",
            "other": "00 milliards"
          },
          "100000000000": {
            "one": "000 milliards",
            "other": "000 milliards"
          },
          "1000000000000": {
            "one": "0 billion",
            "other": "0 billions"
          },
          "10000000000000": {
            "one": "00 billions",
            "other": "00 billions"
          },
          "100000000000000": {
            "one": "000 billions",
            "other": "000 billions"
          }
        },
        "short": {
          "1000": {
            "one": "0 k",
            "other": "0 k"
          },
          "10000": {
            "one": "00 k",
            "other": "00 k"
          },
          "100000": {
            "one": "000 k",
            "other": "000 k"
          },
          "1000000": {
            "one": "0 M",
            "other": "0 M"
          },
          "10000000": {
            "one": "00 M",
            "other": "00 M"
          },
          "100000000": {
            "one": "000 M",
            "other": "000 M"
          },
          "1000000000": {
            "one": "0 Md",
            "other": "0 Md"
          },
          "10000000000": {
            "one": "00 Md",
            "other": "00 Md"
          },
          "100000000000": {
            "one": "000 Md",
            "other": "000 Md"
          },
          "1000000000000": {
            "one": "0 Bn",
            "other": "0 Bn"
          },
          "10000000000000": {
            "one": "00 Bn",
            "other": "00 Bn"
          },
          "100000000000000": {
            "one": "000 Bn",
            "other": "000 Bn"
          }
        }
      }
    }
  }
});

hns('I18n.translations.he-il', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%n %u",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "₪"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ",",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "בייט",
            "other": "בתים"
          },
          "gb": "ג'יגה-בייט",
          "kb": "קילו-בייט",
          "mb": "מגה-בייט",
          "tb": "טרה-בייט"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " ו",
          "lastWordConnector": " ו"
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " or ",
          "lastWordConnector": ", or "
        }
      }
    }
  }
});

hns('I18n.translations.hr', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": "bajt",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      }
    }
  }
});

hns('I18n.translations.hu', {
  "number": {
    "currency": {
      "format": {
        "delimiter": "",
        "format": "%n %u",
        "precision": 0,
        "separator": ",",
        "significant": true,
        "strip_insignificant_zeros": true
      }
    },
    "format": {
      "delimiter": " ",
      "precision": 2,
      "separator": ",",
      "significant": true,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": "Byte",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      }
    }
  }
});

hns('I18n.translations.id', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%u%n",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 2,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n%u",
        "units": {
          "byte": "Byte",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      }
    }
  }
});

hns('I18n.translations.it', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " e ",
          "lastWordConnector": " e "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " o ",
          "lastWordConnector": " o "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 migliaio",
            "other": "0 migliaia"
          },
          "10000": {
            "one": "00 migliaia",
            "other": "00 migliaia"
          },
          "100000": {
            "one": "000 migliaia",
            "other": "000 migliaia"
          },
          "1000000": {
            "one": "0 milione",
            "other": "0 milioni"
          },
          "10000000": {
            "one": "00 milioni",
            "other": "00 milioni"
          },
          "100000000": {
            "one": "000 milioni",
            "other": "000 milioni"
          },
          "1000000000": {
            "one": "0 miliardo",
            "other": "0 miliardi"
          },
          "10000000000": {
            "one": "00 miliardi",
            "other": "00 miliardi"
          },
          "100000000000": {
            "one": "000 miliardi",
            "other": "000 miliardi"
          },
          "1000000000000": {
            "one": "0 migliaio di miliardi",
            "other": "0 migliaia di miliardi"
          },
          "10000000000000": {
            "one": "00 migliaia di miliardi",
            "other": "00 migliaia di miliardi"
          },
          "100000000000000": {
            "one": "000 migliaia di miliardi",
            "other": "000 migliaia di miliardi"
          }
        },
        "short": {
          "1000": {
            "one": "0",
            "other": "0"
          },
          "10000": {
            "one": "0",
            "other": "0"
          },
          "100000": {
            "one": "0",
            "other": "0"
          },
          "1000000": {
            "one": "0 Mln",
            "other": "0 Mln"
          },
          "10000000": {
            "one": "00 Mln",
            "other": "00 Mln"
          },
          "100000000": {
            "one": "000 Mln",
            "other": "000 Mln"
          },
          "1000000000": {
            "one": "0 Mld",
            "other": "0 Mld"
          },
          "10000000000": {
            "one": "00 Mld",
            "other": "00 Mld"
          },
          "100000000000": {
            "one": "000 Mld",
            "other": "000 Mld"
          },
          "1000000000000": {
            "one": "0 Bln",
            "other": "0 Bln"
          },
          "10000000000000": {
            "one": "00 Bln",
            "other": "00 Bln"
          },
          "100000000000000": {
            "one": "000 Bln",
            "other": "000 Bln"
          }
        }
      }
    }
  }
});

hns('I18n.translations.ja', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 0,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "¥"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": "バイト",
          "gb": "ギガバイト",
          "kb": "キロバイト",
          "mb": "メガバイト",
          "tb": "テラバイト"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": "と",
          "twoWordsConnector": "と",
          "lastWordConnector": "と"
        },
        "exclusive": {
          "wordsConnector": "または",
          "twoWordsConnector": "または",
          "lastWordConnector": "または"
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "other": "0千"
          },
          "10000": {
            "other": "0万"
          },
          "100000": {
            "other": "00万"
          },
          "1000000": {
            "other": "000万"
          },
          "10000000": {
            "other": "0000万"
          },
          "100000000": {
            "other": "0億"
          },
          "1000000000": {
            "other": "00億"
          },
          "10000000000": {
            "other": "000億"
          },
          "100000000000": {
            "other": "0000億"
          },
          "1000000000000": {
            "other": "0兆"
          },
          "10000000000000": {
            "other": "00兆"
          },
          "100000000000000": {
            "other": "000兆"
          }
        },
        "short": {
          "1000": {
            "other": "0千"
          },
          "10000": {
            "other": "0万"
          },
          "100000": {
            "other": "00万"
          },
          "1000000": {
            "other": "000万"
          },
          "10000000": {
            "other": "0000万"
          },
          "100000000": {
            "other": "0億"
          },
          "1000000000": {
            "other": "00億"
          },
          "10000000000": {
            "other": "000億"
          },
          "100000000000": {
            "other": "0000億"
          },
          "1000000000000": {
            "other": "0兆"
          },
          "10000000000000": {
            "other": "00兆"
          },
          "100000000000000": {
            "other": "000兆"
          }
        }
      }
    }
  }
});

hns('I18n.translations.ko', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 0,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ",",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n%u",
        "units": {
          "byte": "바이트",
          "gb": "기가바이트",
          "kb": "킬로바이트",
          "mb": "메가바이트",
          "tb": "테라바이트"
        }
      }
    }
  }
});

hns('I18n.translations.lt', {
  "number": {
    "currency": {
      "format": {
        "delimiter": " ",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": " ",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Baitas",
            "other": "Baitų"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " ir ",
          "lastWordConnector": " ir "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " or ",
          "lastWordConnector": ", or "
        }
      }
    }
  }
});

hns('I18n.translations.nl', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%u%n",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " en ",
          "lastWordConnector": " en "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " of ",
          "lastWordConnector": ", of "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 duizend",
            "other": "0 duizend"
          },
          "10000": {
            "one": "00 duizend",
            "other": "00 duizend"
          },
          "100000": {
            "one": "000 duizend",
            "other": "000 duizend"
          },
          "1000000": {
            "one": "0 miljoen",
            "other": "0 miljoen"
          },
          "10000000": {
            "one": "00 miljoen",
            "other": "00 miljoen"
          },
          "100000000": {
            "one": "000 miljoen",
            "other": "000 miljoen"
          },
          "1000000000": {
            "one": "0 miljard",
            "other": "0 miljard"
          },
          "10000000000": {
            "one": "00 miljard",
            "other": "00 miljard"
          },
          "100000000000": {
            "one": "000 miljard",
            "other": "000 miljard"
          },
          "1000000000000": {
            "one": "0 biljoen",
            "other": "0 biljoen"
          },
          "10000000000000": {
            "one": "00 biljoen",
            "other": "00 biljoen"
          },
          "100000000000000": {
            "one": "000 biljoen",
            "other": "000 biljoen"
          }
        },
        "short": {
          "1000": {
            "one": "0K",
            "other": "0K"
          },
          "10000": {
            "one": "00K",
            "other": "00K"
          },
          "100000": {
            "one": "000K",
            "other": "000K"
          },
          "1000000": {
            "one": "0 mln.",
            "other": "0 mln."
          },
          "10000000": {
            "one": "00 mln.",
            "other": "00 mln."
          },
          "100000000": {
            "one": "000 mln.",
            "other": "000 mln."
          },
          "1000000000": {
            "one": "0 mld.",
            "other": "0 mld."
          },
          "10000000000": {
            "one": "00 mld.",
            "other": "00 mld."
          },
          "100000000000": {
            "one": "000 mld.",
            "other": "000 mld."
          },
          "1000000000000": {
            "one": "0 bln.",
            "other": "0 bln."
          },
          "10000000000000": {
            "one": "00 bln.",
            "other": "00 bln."
          },
          "100000000000000": {
            "one": "000 bln.",
            "other": "000 bln."
          }
        }
      }
    }
  }
});

hns('I18n.translations.no-no', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%u%n",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ".",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "kB",
          "mb": "MB",
          "tb": "TB"
        }
      }
    }
  }
});

hns('I18n.translations.pl', {
  "number": {
    "currency": {
      "format": {
        "delimiter": " ",
        "format": "%u%n",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": true
      }
    },
    "format": {
      "delimiter": " ",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": " ",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "bajt",
            "few": "bajty",
            "many": "bajtów",
            "other": "bajty"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      }
    }
  }
});

hns('I18n.translations.pt-br', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%u%n",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "R$"
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ".",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " e ",
          "lastWordConnector": " e "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " ou ",
          "lastWordConnector": ", ou "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 mil",
            "other": "0 mil"
          },
          "10000": {
            "one": "00 mil",
            "other": "00 mil"
          },
          "100000": {
            "one": "000 mil",
            "other": "000 mil"
          },
          "1000000": {
            "one": "0 milhão",
            "other": "0 milhões"
          },
          "10000000": {
            "one": "00 milhão",
            "other": "00 milhões"
          },
          "100000000": {
            "one": "000 milhão",
            "other": "000 milhões"
          },
          "1000000000": {
            "one": "0 bilhão",
            "other": "0 bilhões"
          },
          "10000000000": {
            "one": "00 bilhão",
            "other": "00 bilhões"
          },
          "100000000000": {
            "one": "000 bilhão",
            "other": "000 bilhões"
          },
          "1000000000000": {
            "one": "0 trilhão",
            "other": "0 trilhões"
          },
          "10000000000000": {
            "one": "00 trilhão",
            "other": "00 trilhões"
          },
          "100000000000000": {
            "one": "000 trilhão",
            "other": "000 trilhões"
          }
        },
        "short": {
          "1000": {
            "one": "0 mil",
            "other": "0 mil"
          },
          "10000": {
            "one": "00 mil",
            "other": "00 mil"
          },
          "100000": {
            "one": "000 mil",
            "other": "000 mil"
          },
          "1000000": {
            "one": "0 mi",
            "other": "0 mi"
          },
          "10000000": {
            "one": "00 mi",
            "other": "00 mi"
          },
          "100000000": {
            "one": "000 mi",
            "other": "000 mi"
          },
          "1000000000": {
            "one": "0 bi",
            "other": "0 bi"
          },
          "10000000000": {
            "one": "00 bi",
            "other": "00 bi"
          },
          "100000000000": {
            "one": "000 bi",
            "other": "000 bi"
          },
          "1000000000000": {
            "one": "0 tri",
            "other": "0 tri"
          },
          "10000000000000": {
            "one": "00 tri",
            "other": "00 tri"
          },
          "100000000000000": {
            "one": "000 tri",
            "other": "000 tri"
          }
        }
      }
    }
  }
});

hns('I18n.translations.ro', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ",",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n%u",
        "units": {
          "byte": "Byte",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      }
    }
  }
});

hns('I18n.translations.ru', {
  "number": {
    "currency": {
      "format": {
        "delimiter": " ",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      }
    },
    "format": {
      "delimiter": " ",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n%u",
        "units": {
          "byte": "байт",
          "gb": "ГБ",
          "kb": "КБ",
          "mb": "МБ",
          "tb": "ТБ"
        }
      }
    }
  }
});

hns('I18n.translations.sk', {
  "number": {
    "currency": {
      "format": {
        "delimiter": " ",
        "format": "%n %u",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": " ",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": " ",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "B",
            "other": "B"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " a  ",
          "lastWordConnector": " a  "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " or ",
          "lastWordConnector": ", or "
        }
      }
    }
  }
});

hns('I18n.translations.sv', {
  "number": {
    "currency": {
      "format": {
        "delimiter": " ",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "kr"
      }
    },
    "format": {
      "delimiter": " ",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " och ",
          "lastWordConnector": " och "
        },
        "exclusive": {
          "wordsConnector": ", ",
          "twoWordsConnector": " eller ",
          "lastWordConnector": ", eller "
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "one": "0 tusen",
            "other": "0 tusen"
          },
          "10000": {
            "one": "00 tusen",
            "other": "00 tusen"
          },
          "100000": {
            "one": "000 tusen",
            "other": "000 tusen"
          },
          "1000000": {
            "one": "0 miljon",
            "other": "0 miljoner"
          },
          "10000000": {
            "one": "00 miljon",
            "other": "00 miljoner"
          },
          "100000000": {
            "one": "000 miljoner",
            "other": "000 miljoner"
          },
          "1000000000": {
            "one": "0 miljard",
            "other": "0 miljarder"
          },
          "10000000000": {
            "one": "00 miljarder",
            "other": "00 miljarder"
          },
          "100000000000": {
            "one": "000 miljarder",
            "other": "000 miljarder"
          },
          "1000000000000": {
            "one": "0 biljon",
            "other": "0 biljoner"
          },
          "10000000000000": {
            "one": "00 biljoner",
            "other": "00 biljoner"
          },
          "100000000000000": {
            "one": "000 biljoner",
            "other": "000 biljoner"
          }
        },
        "short": {
          "1000": {
            "one": "0 tn",
            "other": "0 tn"
          },
          "10000": {
            "one": "00 tn",
            "other": "00 tn"
          },
          "100000": {
            "one": "000 tn",
            "other": "000 tn"
          },
          "1000000": {
            "one": "0 mn",
            "other": "0 mn"
          },
          "10000000": {
            "one": "00 mn",
            "other": "00 mn"
          },
          "100000000": {
            "one": "000 mn",
            "other": "000 mn"
          },
          "1000000000": {
            "one": "0 md",
            "other": "0 md"
          },
          "10000000000": {
            "one": "00 md",
            "other": "00 md"
          },
          "100000000000": {
            "one": "000 md",
            "other": "000 md"
          },
          "1000000000000": {
            "one": "0 bn",
            "other": "0 bn"
          },
          "10000000000000": {
            "one": "00 bn",
            "other": "00 bn"
          },
          "100000000000000": {
            "one": "000 bn",
            "other": "000 bn"
          }
        }
      }
    }
  }
});

hns('I18n.translations.th', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%n %u",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": ",",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": "ไบต์",
          "gb": "จิกะไบต์",
          "kb": "กิโลไบต์",
          "mb": "เมกะไบต์",
          "tb": "เทระไบต์"
        }
      }
    }
  }
});

hns('I18n.translations.vi', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%n %u",
        "precision": 0,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n%u",
        "units": {
          "byte": "Byte",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      }
    }
  }
});

hns('I18n.translations.zh-cn', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u %n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "CN¥"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": "、 ",
          "twoWordsConnector": "和",
          "lastWordConnector": "和"
        },
        "exclusive": {
          "wordsConnector": "、 ",
          "twoWordsConnector": "或",
          "lastWordConnector": "或"
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "other": "0千"
          },
          "10000": {
            "other": "0万"
          },
          "100000": {
            "other": "00万"
          },
          "1000000": {
            "other": "000万"
          },
          "10000000": {
            "other": "0000万"
          },
          "100000000": {
            "other": "0亿"
          },
          "1000000000": {
            "other": "00亿"
          },
          "10000000000": {
            "other": "000亿"
          },
          "100000000000": {
            "other": "0000亿"
          },
          "1000000000000": {
            "other": "0兆"
          },
          "10000000000000": {
            "other": "00兆"
          },
          "100000000000000": {
            "other": "000兆"
          }
        },
        "short": {
          "1000": {
            "other": "0千"
          },
          "10000": {
            "other": "0万"
          },
          "100000": {
            "other": "00万"
          },
          "1000000": {
            "other": "000万"
          },
          "10000000": {
            "other": "0000万"
          },
          "100000000": {
            "other": "0亿"
          },
          "1000000000": {
            "other": "00亿"
          },
          "10000000000": {
            "other": "000亿"
          },
          "100000000000": {
            "other": "0000亿"
          },
          "1000000000000": {
            "other": "0兆"
          },
          "10000000000000": {
            "other": "00兆"
          },
          "100000000000000": {
            "other": "000兆"
          }
        }
      }
    }
  }
});

hns('I18n.translations.zh-hk', {
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u %n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "HK$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": true
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%",
        "precision": 0
      }
    },
    "human": {
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "tb": "TB"
        }
      },
      "array": {
        "inclusive": {
          "wordsConnector": "、",
          "twoWordsConnector": "和",
          "lastWordConnector": "和"
        },
        "exclusive": {
          "wordsConnector": "、 ",
          "twoWordsConnector": "或",
          "lastWordConnector": "或"
        }
      },
      "abbreviated": {
        "long": {
          "1000": {
            "other": "0 千"
          },
          "10000": {
            "other": "0萬"
          },
          "100000": {
            "other": "00萬"
          },
          "1000000": {
            "other": "000萬"
          },
          "10000000": {
            "other": "0000萬"
          },
          "100000000": {
            "other": "0億"
          },
          "1000000000": {
            "other": "00億"
          },
          "10000000000": {
            "other": "000億"
          },
          "100000000000": {
            "other": "0000億"
          },
          "1000000000000": {
            "other": "0兆"
          },
          "10000000000000": {
            "other": "00兆"
          },
          "100000000000000": {
            "other": "000兆"
          }
        },
        "short": {
          "1000": {
            "other": "0K"
          },
          "10000": {
            "other": "00K"
          },
          "100000": {
            "other": "000K"
          },
          "1000000": {
            "other": "0M"
          },
          "10000000": {
            "other": "00M"
          },
          "100000000": {
            "other": "000M"
          },
          "1000000000": {
            "other": "0B"
          },
          "10000000000": {
            "other": "00B"
          },
          "100000000000": {
            "other": "000B"
          },
          "1000000000000": {
            "other": "0T"
          },
          "10000000000000": {
            "other": "00T"
          },
          "100000000000000": {
            "other": "000T"
          }
        }
      }
    }
  }
});




hns('I18n.baseLocales', {
  "en": {
    "language": "en",
    "beta": false,
    "defaultLocale": "en-us",
    "availableLocale": [
      "en-us",
      "en-ca",
      "en-gb",
      "en-ie",
      "en-au",
      "en-nz",
      "en-in",
      "es-ar",
      "es-mx",
      "es",
      "pt-br",
      "de",
      "fr",
      "it",
      "fi",
      "sv",
      "nl",
      "ja",
      "zh-cn",
      "zh-hk"
    ]
  },
  "es": {
    "language": "es",
    "beta": false,
    "defaultLocale": "es-ar",
    "availableLocale": [
      "es",
      "es-ar",
      "es-mx"
    ]
  },
  "de": {
    "language": "de",
    "beta": false,
    "defaultLocale": "de",
    "availableLocale": [
      "de"
    ]
  },
  "ja": {
    "language": "ja",
    "beta": false,
    "defaultLocale": "ja",
    "availableLocale": [
      "ja"
    ]
  },
  "fr": {
    "language": "fr",
    "beta": false,
    "defaultLocale": "fr",
    "availableLocale": [
      "fr",
      "fr-ca"
    ]
  },
  "pt-br": {
    "language": "pt",
    "beta": false,
    "defaultLocale": "pt-br",
    "availableLocale": [
      "pt-br"
    ]
  },
  "nl": {
    "language": "nl",
    "beta": false,
    "defaultLocale": "nl",
    "availableLocale": [
      "nl"
    ]
  },
  "it": {
    "language": "it",
    "beta": false,
    "defaultLocale": "it",
    "availableLocale": [
      "it"
    ]
  }
});

hns('I18n.publicLocales', {
  "af": {
    "language": "af",
    "beta": true,
    "defaultLocale": "af",
    "availableLocale": [
      "af"
    ]
  },
  "ar-eg": {
    "language": "ar-eg",
    "beta": true,
    "defaultLocale": "ar-eg",
    "availableLocale": [
      "ar-eg"
    ]
  },
  "bg": {
    "language": "bg",
    "beta": true,
    "defaultLocale": "bg",
    "availableLocale": [
      "bg"
    ]
  },
  "bn": {
    "language": "bn",
    "beta": true,
    "defaultLocale": "bn",
    "availableLocale": [
      "bn"
    ]
  },
  "ca-es": {
    "language": "ca-es",
    "beta": true,
    "defaultLocale": "ca-es",
    "availableLocale": [
      "ca-es"
    ]
  },
  "cs": {
    "language": "cs",
    "beta": true,
    "defaultLocale": "cs",
    "availableLocale": [
      "cs"
    ]
  },
  "da": {
    "language": "da",
    "beta": true,
    "defaultLocale": "da",
    "availableLocale": [
      "da"
    ]
  },
  "el": {
    "language": "el",
    "beta": true,
    "defaultLocale": "el",
    "availableLocale": [
      "el"
    ]
  },
  "en-gb": {
    "language": "en-gb",
    "beta": true,
    "defaultLocale": "en-gb",
    "availableLocale": [
      "en-gb"
    ]
  },
  "es-mx": {
    "language": "es-mx",
    "beta": true,
    "defaultLocale": "es-mx",
    "availableLocale": [
      "es-mx"
    ]
  },
  "fi": {
    "language": "fi",
    "beta": true,
    "defaultLocale": "fi",
    "availableLocale": [
      "fi"
    ]
  },
  "fr-ca": {
    "language": "fr-ca",
    "beta": true,
    "defaultLocale": "fr-ca",
    "availableLocale": [
      "fr-ca"
    ]
  },
  "he-il": {
    "language": "he-il",
    "beta": true,
    "defaultLocale": "he-il",
    "availableLocale": [
      "he-il"
    ]
  },
  "hr": {
    "language": "hr",
    "beta": true,
    "defaultLocale": "hr",
    "availableLocale": [
      "hr"
    ]
  },
  "hu": {
    "language": "hu",
    "beta": true,
    "defaultLocale": "hu",
    "availableLocale": [
      "hu"
    ]
  },
  "id": {
    "language": "id",
    "beta": true,
    "defaultLocale": "id",
    "availableLocale": [
      "id"
    ]
  },
  "ko": {
    "language": "ko",
    "beta": true,
    "defaultLocale": "ko",
    "availableLocale": [
      "ko"
    ]
  },
  "lt": {
    "language": "lt",
    "beta": true,
    "defaultLocale": "lt",
    "availableLocale": [
      "lt"
    ]
  },
  "no-no": {
    "language": "no-no",
    "beta": true,
    "defaultLocale": "no-no",
    "availableLocale": [
      "no-no"
    ]
  },
  "pl": {
    "language": "pl",
    "beta": true,
    "defaultLocale": "pl",
    "availableLocale": [
      "pl"
    ]
  },
  "ro": {
    "language": "ro",
    "beta": true,
    "defaultLocale": "ro",
    "availableLocale": [
      "ro"
    ]
  },
  "ru": {
    "language": "ru",
    "beta": true,
    "defaultLocale": "ru",
    "availableLocale": [
      "ru"
    ]
  },
  "sk": {
    "language": "sk",
    "beta": true,
    "defaultLocale": "sk",
    "availableLocale": [
      "sk"
    ]
  },
  "sl": {
    "language": "sl",
    "beta": true,
    "defaultLocale": "sl",
    "availableLocale": [
      "sl"
    ]
  },
  "sv": {
    "language": "sv",
    "beta": true,
    "defaultLocale": "sv",
    "availableLocale": [
      "sv-fi",
      "sv"
    ]
  },
  "th": {
    "language": "th",
    "beta": true,
    "defaultLocale": "th",
    "availableLocale": [
      "th"
    ]
  },
  "tr": {
    "language": "tr",
    "beta": true,
    "defaultLocale": "tr",
    "availableLocale": [
      "tr"
    ]
  },
  "uk": {
    "language": "uk",
    "beta": true,
    "defaultLocale": "uk",
    "availableLocale": [
      "uk"
    ]
  },
  "vi": {
    "language": "vi",
    "beta": true,
    "defaultLocale": "vi",
    "availableLocale": [
      "vi"
    ]
  },
  "zh-cn": {
    "language": "zh-cn",
    "beta": true,
    "defaultLocale": "zh-cn",
    "availableLocale": [
      "zh-cn"
    ]
  },
  "zh-hk": {
    "language": "zh-hk",
    "beta": true,
    "defaultLocale": "zh-hk",
    "availableLocale": [
      "zh-hk"
    ]
  }
});

hns('I18n.currencySymbols', {
  "USD": {
    "symbol": "$",
    "name": "US Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "USD",
    "name_plural": "US dollars"
  },
  "CAD": {
    "symbol": "CA$",
    "name": "Canadian Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CAD",
    "name_plural": "Canadian dollars"
  },
  "EUR": {
    "symbol": "€",
    "name": "Euro",
    "symbol_native": "€",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "EUR",
    "name_plural": "euros"
  },
  "AED": {
    "symbol": "AED",
    "name": "United Arab Emirates Dirham",
    "symbol_native": "د.إ.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "AED",
    "name_plural": "UAE dirhams"
  },
  "AFN": {
    "symbol": "Af",
    "name": "Afghan Afghani",
    "symbol_native": "؋",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "AFN",
    "name_plural": "Afghan Afghanis"
  },
  "ALL": {
    "symbol": "ALL",
    "name": "Albanian Lek",
    "symbol_native": "Lek",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "ALL",
    "name_plural": "Albanian lekë"
  },
  "AMD": {
    "symbol": "AMD",
    "name": "Armenian Dram",
    "symbol_native": "դր.",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "AMD",
    "name_plural": "Armenian drams"
  },
  "AOA": {
    "symbol": "Kz",
    "name": "Angolan kwanza",
    "symbol_native": "Kz",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "AOA",
    "name_plural": "Angolan kwanzas"
  },
  "ARS": {
    "symbol": "AR$",
    "name": "Argentine Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ARS",
    "name_plural": "Argentine pesos"
  },
  "AUD": {
    "symbol": "AU$",
    "name": "Australian Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "AUD",
    "name_plural": "Australian dollars"
  },
  "AZN": {
    "symbol": "man.",
    "name": "Azerbaijani Manat",
    "symbol_native": "ман.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "AZN",
    "name_plural": "Azerbaijani manats"
  },
  "BAM": {
    "symbol": "KM",
    "name": "Bosnia-Herzegovina Convertible Mark",
    "symbol_native": "KM",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BAM",
    "name_plural": "Bosnia-Herzegovina convertible marks"
  },
  "BDT": {
    "symbol": "Tk",
    "name": "Bangladeshi Taka",
    "symbol_native": "৳",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BDT",
    "name_plural": "Bangladeshi takas"
  },
  "BGN": {
    "symbol": "BGN",
    "name": "Bulgarian Lev",
    "symbol_native": "лв.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BGN",
    "name_plural": "Bulgarian leva"
  },
  "BHD": {
    "symbol": "BD",
    "name": "Bahraini Dinar",
    "symbol_native": "د.ب.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "BHD",
    "name_plural": "Bahraini dinars"
  },
  "BIF": {
    "symbol": "FBu",
    "name": "Burundian Franc",
    "symbol_native": "FBu",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "BIF",
    "name_plural": "Burundian francs"
  },
  "BND": {
    "symbol": "BN$",
    "name": "Brunei Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BND",
    "name_plural": "Brunei dollars"
  },
  "BOB": {
    "symbol": "Bs",
    "name": "Bolivian Boliviano",
    "symbol_native": "Bs",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BOB",
    "name_plural": "Bolivian bolivianos"
  },
  "BRL": {
    "symbol": "R$",
    "name": "Brazilian Real",
    "symbol_native": "R$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BRL",
    "name_plural": "Brazilian reals"
  },
  "BWP": {
    "symbol": "BWP",
    "name": "Botswanan Pula",
    "symbol_native": "P",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BWP",
    "name_plural": "Botswanan pulas"
  },
  "BYR": {
    "symbol": "BYR",
    "name": "Belarusian Ruble",
    "symbol_native": "BYR",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "BYR",
    "name_plural": "Belarusian rubles"
  },
  "BZD": {
    "symbol": "BZ$",
    "name": "Belize Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BZD",
    "name_plural": "Belize dollars"
  },
  "CDF": {
    "symbol": "CDF",
    "name": "Congolese Franc",
    "symbol_native": "FrCD",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CDF",
    "name_plural": "Congolese francs"
  },
  "CHF": {
    "symbol": "CHF",
    "name": "Swiss Franc",
    "symbol_native": "CHF",
    "decimal_digits": 2,
    "rounding": 0.05,
    "code": "CHF",
    "name_plural": "Swiss francs"
  },
  "CLF": {
    "symbol": "UF",
    "name": "Unidad de Fomento",
    "symbol_native": "UF",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CLF",
    "name_plural": "Unidades de Fomento"
  },
  "CLP": {
    "symbol": "CL$",
    "name": "Chilean Peso",
    "symbol_native": "$",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "CLP",
    "name_plural": "Chilean pesos",
    "alternative_decimal_digits": 2
  },
  "CNY": {
    "symbol": "CN¥",
    "name": "Chinese Yuan",
    "symbol_native": "CN¥",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CNY",
    "name_plural": "Chinese yuan"
  },
  "COP": {
    "symbol": "COP",
    "name": "Colombian Peso",
    "symbol_native": "$",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "COP",
    "name_plural": "Colombian pesos",
    "alternative_decimal_digits": 2
  },
  "CRC": {
    "symbol": "₡",
    "name": "Costa Rican Colón",
    "symbol_native": "₡",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "CRC",
    "name_plural": "Costa Rican colóns"
  },
  "CVE": {
    "symbol": "CV$",
    "name": "Cape Verdean Escudo",
    "symbol_native": "CV$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CVE",
    "name_plural": "Cape Verdean escudos"
  },
  "CZK": {
    "symbol": "Kč",
    "name": "Czech Republic Koruna",
    "symbol_native": "Kč",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CZK",
    "name_plural": "Czech Republic korunas"
  },
  "DJF": {
    "symbol": "Fdj",
    "name": "Djiboutian Franc",
    "symbol_native": "Fdj",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "DJF",
    "name_plural": "Djiboutian francs"
  },
  "DKK": {
    "symbol": "kr.",
    "name": "Danish Krone",
    "symbol_native": "kr.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "DKK",
    "name_plural": "Danish kroner"
  },
  "DOP": {
    "symbol": "RD$",
    "name": "Dominican Peso",
    "symbol_native": "RD$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "DOP",
    "name_plural": "Dominican pesos"
  },
  "DZD": {
    "symbol": "DA",
    "name": "Algerian Dinar",
    "symbol_native": "د.ج.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "DZD",
    "name_plural": "Algerian dinars"
  },
  "EEK": {
    "symbol": "Ekr",
    "name": "Estonian Kroon",
    "symbol_native": "kr",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "EEK",
    "name_plural": "Estonian kroons"
  },
  "EGP": {
    "symbol": "EGP",
    "name": "Egyptian Pound",
    "symbol_native": "ج.م.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "EGP",
    "name_plural": "Egyptian pounds"
  },
  "ERN": {
    "symbol": "Nfk",
    "name": "Eritrean Nakfa",
    "symbol_native": "Nfk",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ERN",
    "name_plural": "Eritrean nakfas"
  },
  "ETB": {
    "symbol": "Br",
    "name": "Ethiopian Birr",
    "symbol_native": "Br",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ETB",
    "name_plural": "Ethiopian birrs"
  },
  "GBP": {
    "symbol": "£",
    "name": "British Pound Sterling",
    "symbol_native": "£",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GBP",
    "name_plural": "British pounds sterling"
  },
  "GEL": {
    "symbol": "GEL",
    "name": "Georgian Lari",
    "symbol_native": "GEL",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GEL",
    "name_plural": "Georgian laris"
  },
  "GHS": {
    "symbol": "GH₵",
    "name": "Ghanaian Cedi",
    "symbol_native": "GH₵",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GHS",
    "name_plural": "Ghanaian cedis"
  },
  "GNF": {
    "symbol": "FG",
    "name": "Guinean Franc",
    "symbol_native": "FG",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "GNF",
    "name_plural": "Guinean francs"
  },
  "GTQ": {
    "symbol": "GTQ",
    "name": "Guatemalan Quetzal",
    "symbol_native": "Q",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GTQ",
    "name_plural": "Guatemalan quetzals"
  },
  "HKD": {
    "symbol": "HK$",
    "name": "Hong Kong Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "HKD",
    "name_plural": "Hong Kong dollars"
  },
  "HNL": {
    "symbol": "HNL",
    "name": "Honduran Lempira",
    "symbol_native": "L",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "HNL",
    "name_plural": "Honduran lempiras"
  },
  "HRK": {
    "symbol": "kn",
    "name": "Croatian Kuna",
    "symbol_native": "kn",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "HRK",
    "name_plural": "Croatian kunas"
  },
  "HUF": {
    "symbol": "Ft",
    "name": "Hungarian Forint",
    "symbol_native": "Ft",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "HUF",
    "name_plural": "Hungarian forints"
  },
  "IDR": {
    "symbol": "Rp",
    "name": "Indonesian Rupiah",
    "symbol_native": "Rp",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "IDR",
    "name_plural": "Indonesian rupiahs"
  },
  "ILS": {
    "symbol": "₪",
    "name": "Israeli New Shekel",
    "symbol_native": "₪",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ILS",
    "name_plural": "Israeli new shekels"
  },
  "INR": {
    "symbol": "Rs",
    "name": "Indian Rupee",
    "symbol_native": "₹",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "INR",
    "name_plural": "Indian rupees"
  },
  "IQD": {
    "symbol": "IQD",
    "name": "Iraqi Dinar",
    "symbol_native": "د.ع.‏",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "IQD",
    "name_plural": "Iraqi dinars"
  },
  "IRR": {
    "symbol": "IRR",
    "name": "Iranian Rial",
    "symbol_native": "﷼",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "IRR",
    "name_plural": "Iranian rials"
  },
  "ISK": {
    "symbol": "Ikr",
    "name": "Icelandic Króna",
    "symbol_native": "kr",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "ISK",
    "name_plural": "Icelandic krónur"
  },
  "JMD": {
    "symbol": "J$",
    "name": "Jamaican Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "JMD",
    "name_plural": "Jamaican dollars"
  },
  "JOD": {
    "symbol": "JD",
    "name": "Jordanian Dinar",
    "symbol_native": "د.أ.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "JOD",
    "name_plural": "Jordanian dinars"
  },
  "JPY": {
    "symbol": "¥",
    "name": "Japanese Yen",
    "symbol_native": "￥",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "JPY",
    "name_plural": "Japanese yen"
  },
  "KES": {
    "symbol": "Ksh",
    "name": "Kenyan Shilling",
    "symbol_native": "Ksh",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "KES",
    "name_plural": "Kenyan shillings"
  },
  "KHR": {
    "symbol": "KHR",
    "name": "Cambodian Riel",
    "symbol_native": "៛",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "KHR",
    "name_plural": "Cambodian riels"
  },
  "KMF": {
    "symbol": "CF",
    "name": "Comorian Franc",
    "symbol_native": "FC",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "KMF",
    "name_plural": "Comorian francs"
  },
  "KRW": {
    "symbol": "₩",
    "name": "South Korean Won",
    "symbol_native": "₩",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "KRW",
    "name_plural": "South Korean won"
  },
  "KWD": {
    "symbol": "KD",
    "name": "Kuwaiti Dinar",
    "symbol_native": "د.ك.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "KWD",
    "name_plural": "Kuwaiti dinars"
  },
  "KZT": {
    "symbol": "KZT",
    "name": "Kazakhstani Tenge",
    "symbol_native": "тңг.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "KZT",
    "name_plural": "Kazakhstani tenges"
  },
  "LBP": {
    "symbol": "LB£",
    "name": "Lebanese Pound",
    "symbol_native": "ل.ل.‏",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "LBP",
    "name_plural": "Lebanese pounds"
  },
  "LKR": {
    "symbol": "SLRs",
    "name": "Sri Lankan Rupee",
    "symbol_native": "SL Re",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LKR",
    "name_plural": "Sri Lankan rupees"
  },
  "LTL": {
    "symbol": "Lt",
    "name": "Lithuanian Litas",
    "symbol_native": "Lt",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LTL",
    "name_plural": "Lithuanian litai"
  },
  "LVL": {
    "symbol": "Ls",
    "name": "Latvian Lats",
    "symbol_native": "Ls",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LVL",
    "name_plural": "Latvian lati"
  },
  "LYD": {
    "symbol": "L$",
    "name": "Libyan Dinar",
    "symbol_native": "د.ل.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "LYD",
    "name_plural": "Libyan dinars"
  },
  "MAD": {
    "symbol": "MAD",
    "name": "Moroccan Dirham",
    "symbol_native": "د.م.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MAD",
    "name_plural": "Moroccan dirhams"
  },
  "MDL": {
    "symbol": "MDL",
    "name": "Moldovan Leu",
    "symbol_native": "MDL",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MDL",
    "name_plural": "Moldovan lei"
  },
  "MGA": {
    "symbol": "MGA",
    "name": "Malagasy Ariary",
    "symbol_native": "MGA",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "MGA",
    "name_plural": "Malagasy Ariaries"
  },
  "MKD": {
    "symbol": "MKD",
    "name": "Macedonian Denar",
    "symbol_native": "MKD",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MKD",
    "name_plural": "Macedonian denari"
  },
  "MMK": {
    "symbol": "MMK",
    "name": "Myanma Kyat",
    "symbol_native": "K",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "MMK",
    "name_plural": "Myanma kyats"
  },
  "MNT": {
    "symbol": "MNT",
    "name": "Mongolian Tughrik",
    "symbol_native": "₮",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MNT",
    "name_plural": "Mongolian tögrög"
  },
  "MOP": {
    "symbol": "MOP$",
    "name": "Macanese Pataca",
    "symbol_native": "MOP$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MOP",
    "name_plural": "Macanese patacas"
  },
  "MRO": {
    "symbol": "UM",
    "name": "Mauritanian ouguiya",
    "symbol_native": "UM",
    "decimal_digits": 1,
    "rounding": 0,
    "code": "MRO",
    "name_plural": "Mauritanian ouguiya"
  },
  "MUR": {
    "symbol": "MURs",
    "name": "Mauritian Rupee",
    "symbol_native": "MURs",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "MUR",
    "name_plural": "Mauritian rupees"
  },
  "MXN": {
    "symbol": "MX$",
    "name": "Mexican Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MXN",
    "name_plural": "Mexican pesos"
  },
  "MYR": {
    "symbol": "RM",
    "name": "Malaysian Ringgit",
    "symbol_native": "RM",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MYR",
    "name_plural": "Malaysian ringgits"
  },
  "MZN": {
    "symbol": "MTn",
    "name": "Mozambican Metical",
    "symbol_native": "MTn",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MZN",
    "name_plural": "Mozambican meticals"
  },
  "NAD": {
    "symbol": "N$",
    "name": "Namibian Dollar",
    "symbol_native": "N$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NAD",
    "name_plural": "Namibian dollars"
  },
  "NGN": {
    "symbol": "₦",
    "name": "Nigerian Naira",
    "symbol_native": "₦",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NGN",
    "name_plural": "Nigerian nairas"
  },
  "NIO": {
    "symbol": "C$",
    "name": "Nicaraguan Córdoba",
    "symbol_native": "C$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NIO",
    "name_plural": "Nicaraguan córdobas"
  },
  "NOK": {
    "symbol": "kr",
    "name": "Norwegian Krone",
    "symbol_native": "kr",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NOK",
    "name_plural": "Norwegian kroner"
  },
  "NPR": {
    "symbol": "NPRs",
    "name": "Nepalese Rupee",
    "symbol_native": "नेरू",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NPR",
    "name_plural": "Nepalese rupees"
  },
  "NZD": {
    "symbol": "NZ$",
    "name": "New Zealand Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NZD",
    "name_plural": "New Zealand dollars"
  },
  "OMR": {
    "symbol": "OMR",
    "name": "Omani Rial",
    "symbol_native": "ر.ع.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "OMR",
    "name_plural": "Omani rials"
  },
  "PAB": {
    "symbol": "B/.",
    "name": "Panamanian Balboa",
    "symbol_native": "B/.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PAB",
    "name_plural": "Panamanian balboas"
  },
  "PEN": {
    "symbol": "S/",
    "name": "Peruvian Nuevo Sol",
    "symbol_native": "S/",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PEN",
    "name_plural": "Peruvian nuevos soles"
  },
  "PGK": {
    "symbol": "K",
    "name": "Papua New Guinean kina",
    "symbol_native": "K",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PGK",
    "name_plural": "Papua New Guinean kina"
  },
  "PHP": {
    "symbol": "₱",
    "name": "Philippine Peso",
    "symbol_native": "₱",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PHP",
    "name_plural": "Philippine pesos"
  },
  "PKR": {
    "symbol": "PKRs",
    "name": "Pakistani Rupee",
    "symbol_native": "₨",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "PKR",
    "name_plural": "Pakistani rupees"
  },
  "PLN": {
    "symbol": "zł",
    "name": "Polish Zloty",
    "symbol_native": "zł",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PLN",
    "name_plural": "Polish zlotys"
  },
  "PYG": {
    "symbol": "₲",
    "name": "Paraguayan Guarani",
    "symbol_native": "₲",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "PYG",
    "name_plural": "Paraguayan guaranis"
  },
  "QAR": {
    "symbol": "QR",
    "name": "Qatari Rial",
    "symbol_native": "ر.ق.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "QAR",
    "name_plural": "Qatari rials"
  },
  "RON": {
    "symbol": "RON",
    "name": "Romanian Leu",
    "symbol_native": "RON",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "RON",
    "name_plural": "Romanian lei"
  },
  "RSD": {
    "symbol": "din.",
    "name": "Serbian Dinar",
    "symbol_native": "дин.",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "RSD",
    "name_plural": "Serbian dinars"
  },
  "RUB": {
    "symbol": "RUB",
    "name": "Russian Ruble",
    "symbol_native": "руб.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "RUB",
    "name_plural": "Russian rubles"
  },
  "RWF": {
    "symbol": "RWF",
    "name": "Rwandan Franc",
    "symbol_native": "FR",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "RWF",
    "name_plural": "Rwandan francs"
  },
  "SAR": {
    "symbol": "SR",
    "name": "Saudi Riyal",
    "symbol_native": "ر.س.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SAR",
    "name_plural": "Saudi riyals"
  },
  "SDG": {
    "symbol": "SDG",
    "name": "Sudanese Pound",
    "symbol_native": "SDG",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SDG",
    "name_plural": "Sudanese pounds"
  },
  "SEK": {
    "symbol": "SEK",
    "name": "Swedish Krona",
    "symbol_native": "kr",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SEK",
    "name_plural": "Swedish kronor"
  },
  "SGD": {
    "symbol": "S$",
    "name": "Singapore Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SGD",
    "name_plural": "Singapore dollars"
  },
  "SOS": {
    "symbol": "Ssh",
    "name": "Somali Shilling",
    "symbol_native": "Ssh",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "SOS",
    "name_plural": "Somali shillings"
  },
  "SRD": {
    "symbol": "SR$",
    "name": "Surinamese Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SRD",
    "name_plural": "Surinamese dollars"
  },
  "SYP": {
    "symbol": "SY£",
    "name": "Syrian Pound",
    "symbol_native": "ل.س.‏",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "SYP",
    "name_plural": "Syrian pounds"
  },
  "THB": {
    "symbol": "฿",
    "name": "Thai Baht",
    "symbol_native": "฿",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "THB",
    "name_plural": "Thai baht"
  },
  "TND": {
    "symbol": "DT",
    "name": "Tunisian Dinar",
    "symbol_native": "د.ت.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "TND",
    "name_plural": "Tunisian dinars"
  },
  "TOP": {
    "symbol": "T$",
    "name": "Tongan Paʻanga",
    "symbol_native": "T$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TOP",
    "name_plural": "Tongan paʻanga"
  },
  "TRY": {
    "symbol": "TL",
    "name": "Turkish Lira",
    "symbol_native": "TL",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TRY",
    "name_plural": "Turkish Lira"
  },
  "TTD": {
    "symbol": "TT$",
    "name": "Trinidad and Tobago Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TTD",
    "name_plural": "Trinidad and Tobago dollars"
  },
  "TWD": {
    "symbol": "NT$",
    "name": "New Taiwan Dollar",
    "symbol_native": "NT$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TWD",
    "name_plural": "New Taiwan dollars"
  },
  "TZS": {
    "symbol": "TSh",
    "name": "Tanzanian Shilling",
    "symbol_native": "TSh",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "TZS",
    "name_plural": "Tanzanian shillings"
  },
  "UAH": {
    "symbol": "₴",
    "name": "Ukrainian Hryvnia",
    "symbol_native": "₴",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "UAH",
    "name_plural": "Ukrainian hryvnias"
  },
  "UGX": {
    "symbol": "USh",
    "name": "Ugandan Shilling",
    "symbol_native": "USh",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "UGX",
    "name_plural": "Ugandan shillings"
  },
  "UYU": {
    "symbol": "$U",
    "name": "Uruguayan Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "UYU",
    "name_plural": "Uruguayan pesos"
  },
  "UZS": {
    "symbol": "UZS",
    "name": "Uzbekistan Som",
    "symbol_native": "UZS",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "UZS",
    "name_plural": "Uzbekistan som"
  },
  "VEF": {
    "symbol": "Bs.S.",
    "name": "Venezuelan Bolívar",
    "symbol_native": "Bs.S.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "VEF",
    "name_plural": "Venezuelan bolívars"
  },
  "VND": {
    "symbol": "₫",
    "name": "Vietnamese Dong",
    "symbol_native": "₫",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "VND",
    "name_plural": "Vietnamese dong"
  },
  "XAF": {
    "symbol": "FCFA",
    "name": "CFA Franc BEAC",
    "symbol_native": "FCFA",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "XAF",
    "name_plural": "CFA francs BEAC"
  },
  "XOF": {
    "symbol": "CFA",
    "name": "CFA Franc BCEAO",
    "symbol_native": "CFA",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "XOF",
    "name_plural": "CFA francs BCEAO"
  },
  "YER": {
    "symbol": "YR",
    "name": "Yemeni Rial",
    "symbol_native": "ر.ي.‏",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "YER",
    "name_plural": "Yemeni rials"
  },
  "ZAR": {
    "symbol": "R",
    "name": "South African Rand",
    "symbol_native": "R",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ZAR",
    "name_plural": "South African rand"
  },
  "ZMK": {
    "symbol": "ZK",
    "name": "Zambian Kwacha",
    "symbol_native": "ZK",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "ZMK",
    "name_plural": "Zambian kwachas"
  },
  "ANG": {
    "symbol": "NAƒ",
    "name": "Netherlands Antillean Guilder",
    "symbol_native": "ƒ",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ANG",
    "name_plural": "Netherlands Antillean guilders"
  },
  "AWG": {
    "symbol": "Afl.",
    "name": "Aruban Florin",
    "symbol_native": "Afl.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "AWG",
    "name_plural": "Aruban florin"
  },
  "BBD": {
    "symbol": "Bds$",
    "name": "Barbadian Dollar",
    "symbol_native": "Bds$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BBD",
    "name_plural": "Barbadian dollars"
  },
  "BMD": {
    "symbol": "BD$",
    "name": "Bermudian Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BMD",
    "name_plural": "Bermudian dollars"
  },
  "BOV": {
    "symbol": "Bolivian Mvdol",
    "name": "Bolivian Mvdol",
    "symbol_native": "Bolivian Mvdol",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BOV",
    "name_plural": "Bolivian Mvdol"
  },
  "BSD": {
    "symbol": "B$",
    "name": "Bahamian Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BSD",
    "name_plural": "Bahamian dollars"
  },
  "BTN": {
    "symbol": "Nu.",
    "name": "Bhutanese Ngultrum",
    "symbol_native": "Nu.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BTN",
    "name_plural": "Bhutanese ngultrum"
  },
  "BYN": {
    "symbol": "Br",
    "name": "Belarusian Ruble",
    "symbol_native": "Br",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BYN",
    "name_plural": "Belarusian rubles"
  },
  "CHE": {
    "symbol": "CHE",
    "name": "WIR Euro",
    "symbol_native": "CHE",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CHE",
    "name_plural": "WIR Euro"
  },
  "CHW": {
    "symbol": "CHW",
    "name": "WIR Franc",
    "symbol_native": "CHW",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CHW",
    "name_plural": "WIR Franc"
  },
  "COU": {
    "symbol": "COU",
    "name": "Unidad de Valor Real",
    "symbol_native": "COU",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "COU",
    "name_plural": "Unidad de Valor Real"
  },
  "CUC": {
    "symbol": "CUC$",
    "name": "Cuban Convertible Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CUC",
    "name_plural": "Cuban convertible pesos"
  },
  "CUP": {
    "symbol": "$",
    "name": "Cuban Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CUP",
    "name_plural": "Cuban pesos"
  },
  "FJD": {
    "symbol": "FJ$",
    "name": "Fiji Dollar",
    "symbol_native": "FJ$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "FJD",
    "name_plural": "Fiji dollars"
  },
  "FKP": {
    "symbol": "£",
    "name": "Falkland Islands Pound",
    "symbol_native": "£",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "FKP",
    "name_plural": "Falkland Islands pounds"
  },
  "GIP": {
    "symbol": "£",
    "name": "Gibraltar Pound",
    "symbol_native": "£",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GIP",
    "name_plural": "Gibraltar pounds"
  },
  "GMD": {
    "symbol": "D",
    "name": "Gambian Dalasi",
    "symbol_native": "D",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GMD",
    "name_plural": "Gambian dalasi"
  },
  "GYD": {
    "symbol": "G$",
    "name": "Guyanese Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GYD",
    "name_plural": "Guyanese dollars"
  },
  "HTG": {
    "symbol": "G",
    "name": "Haitian Gourde",
    "symbol_native": "G",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "HTG",
    "name_plural": "Haitian gourdes"
  },
  "KGS": {
    "symbol": "C",
    "name": "Kyrgyzstani Som",
    "symbol_native": "C",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "KGS",
    "name_plural": "Kyrgyzstani som"
  },
  "KPW": {
    "symbol": "₩",
    "name": "North Korean Won",
    "symbol_native": "₩",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "KPW",
    "name_plural": "North Korean won"
  },
  "KYD": {
    "symbol": "CI$",
    "name": "Cayman Islands Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "KYD",
    "name_plural": "Cayman Islands dollars"
  },
  "LAK": {
    "symbol": "₭",
    "name": "Lao Kip",
    "symbol_native": "₭",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LAK",
    "name_plural": "Lao kip"
  },
  "LRD": {
    "symbol": "L$",
    "name": "Liberian Dollar",
    "symbol_native": "L$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LRD",
    "name_plural": "Liberian dollars"
  },
  "LSL": {
    "symbol": "M",
    "name": "Lesotho Loti",
    "symbol_native": "M",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LSL",
    "name_plural": "Lesotho maloti"
  },
  "MRU": {
    "symbol": "UM",
    "name": "Mauritanian Ouguiya",
    "symbol_native": "UM",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MRU",
    "name_plural": "Mauritanian ouguiya"
  },
  "MVR": {
    "symbol": "Rf",
    "name": "Maldivian Rufiyaa",
    "symbol_native": "Rf",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MVR",
    "name_plural": "Maldivian rufiyaa"
  },
  "MWK": {
    "symbol": "K",
    "name": "Malawian Kwacha",
    "symbol_native": "K",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MWK",
    "name_plural": "Malawian kwacha"
  },
  "MXV": {
    "symbol": "MXV",
    "name": "Mexican Unidad de Inversión",
    "symbol_native": "MXV",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MXV",
    "name_plural": "Mexican unidad de inversión"
  },
  "SBD": {
    "symbol": "SI$",
    "name": "Solomon Islands Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SBD",
    "name_plural": "Solomon Islands dollars"
  },
  "SCR": {
    "symbol": "SR",
    "name": "Seychellois Rupee",
    "symbol_native": "SR",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SCR",
    "name_plural": "Seychellois rupees"
  },
  "SHP": {
    "symbol": "£",
    "name": "Saint Helena Pound",
    "symbol_native": "£",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SHP",
    "name_plural": "Saint Helena pounds"
  },
  "SLL": {
    "symbol": "Le",
    "name": "Sierra Leonean Leone",
    "symbol_native": "Le",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SLL",
    "name_plural": "Sierra Leonean leones"
  },
  "SSP": {
    "symbol": "SSP",
    "name": "South Sudanese Pound",
    "symbol_native": "SSP",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SSP",
    "name_plural": "South Sudanese pounds"
  },
  "STN": {
    "symbol": "Db",
    "name": "São Tomé and Príncipe Dobra",
    "symbol_native": "Db",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "STN",
    "name_plural": "São Tomé and Príncipe dobras"
  },
  "SVC": {
    "symbol": "₡",
    "name": "Salvadoran Colón",
    "symbol_native": "₡",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SVC",
    "name_plural": "Salvadoran colones"
  },
  "SZL": {
    "symbol": "E",
    "name": "Swazi Lilangeni",
    "symbol_native": "E",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SZL",
    "name_plural": "Swazi emalangeni"
  },
  "TJS": {
    "symbol": "TJS",
    "name": "Tajikistani Somoni",
    "symbol_native": "TJS",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TJS",
    "name_plural": "Tajikistani somoni"
  },
  "TMT": {
    "symbol": "T",
    "name": "Turkmenistan Manat",
    "symbol_native": "T",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TMT",
    "name_plural": "Turkmenistan manat"
  },
  "USN": {
    "symbol": "$",
    "name": "US dollar (Next day)",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "USN",
    "name_plural": "US dollar (next day)"
  },
  "UYI": {
    "symbol": "UYI",
    "name": "Uruguay Peso en Unidades Indexadas",
    "symbol_native": "UYI",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "UYI",
    "name_plural": "Uruguay Peso en Unidades Indexadas"
  },
  "VUV": {
    "symbol": "VT",
    "name": "Vanuatu Vatu",
    "symbol_native": "VT",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "VUV",
    "name_plural": "Vanuatu vatu"
  },
  "WST": {
    "symbol": "WS$",
    "name": "Samoan Tālā",
    "symbol_native": "WS$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "WST",
    "name_plural": "Samoan tālā"
  },
  "XAG": {
    "symbol": "XAG",
    "name": "Silver",
    "symbol_native": "XAG",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XAG",
    "name_plural": "Silver"
  },
  "XAU": {
    "symbol": "XAU",
    "name": "Gold",
    "symbol_native": "XAU",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XAU",
    "name_plural": "Gold"
  },
  "XBA": {
    "symbol": "XBA",
    "name": "Bond Markets Unit European Composite Unit (EURCO)",
    "symbol_native": "XBA",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XBA",
    "name_plural": "Bond Markets Unit European Composite Unit (EURCO)"
  },
  "XBB": {
    "symbol": "XBB",
    "name": "Bond Markets Unit European Monetary Unit (E.M.U.-6)",
    "symbol_native": "XBB",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XBB",
    "name_plural": "Bond Markets Unit European Monetary Unit (E.M.U.-6)"
  },
  "XBC": {
    "symbol": "XBC",
    "name": "Bond Markets Unit European Unit of Account 9 (E.U.A.-9)9",
    "symbol_native": "XBC",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XBC",
    "name_plural": "Bond Markets Unit European Unit of Account 9 (E.U.A.-9)"
  },
  "XBD": {
    "symbol": "XBD",
    "name": "Bond Markets Unit European Unit of Account 17 (E.U.A.-17)",
    "symbol_native": "XBD",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XBD",
    "name_plural": "Bond Markets Unit European Unit of Account 17 (E.U.A.-17)"
  },
  "XCD": {
    "symbol": "$",
    "name": "East Caribbean Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XCD",
    "name_plural": "East Caribbean Dollar"
  },
  "XDR": {
    "symbol": "SDR",
    "name": "SDR (Special Drawing Right)",
    "symbol_native": "SDR",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XDR",
    "name_plural": "SDR (Special Drawing Right)"
  },
  "XPD": {
    "symbol": "XPD",
    "name": "Palladium",
    "symbol_native": "XPD",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XPD",
    "name_plural": "Palladium"
  },
  "XPF": {
    "symbol": "CFP",
    "name": "CFP Franc",
    "symbol_native": "CFP",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XPF",
    "name_plural": "CFP franc"
  },
  "XPT": {
    "symbol": "XPT",
    "name": "Platinum",
    "symbol_native": "XPT",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XPT",
    "name_plural": "Platinum"
  },
  "XSU": {
    "symbol": "XSU",
    "name": "SUCRE",
    "symbol_native": "XSU",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XSU",
    "name_plural": "SUCRE"
  },
  "XUA": {
    "symbol": "XUA",
    "name": "ADB Unit of Account",
    "symbol_native": "XUA",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "XUA",
    "name_plural": "ADB Unit of Account"
  },
  "ZMW": {
    "symbol": "K",
    "name": "Zambian Kwacha",
    "symbol_native": "K",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ZMW",
    "name_plural": "Zambian kwacha"
  },
  "ZWL": {
    "symbol": "Z$",
    "name": "Zimbabwe Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ZWL",
    "name_plural": "Zimbabwe dollar"
  }
});

"use strict";
'use es6';
'babel noModule';

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  var ABBREVIATE_DEFAULTS = {
    type: 'short',
    precision: 0
  }; // htmlEscape utility function based on Underscore's _.escape

  var htmlEscapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var htmlCharPattern = '(?:&|<|>|"|\'|`)';
  var htmlTestRegexp = RegExp(htmlCharPattern);
  var htmlReplaceRegexp = RegExp(htmlCharPattern, 'g');

  var htmlReplacement = function htmlReplacement(match) {
    return htmlEscapeMap[match];
  };

  var htmlEscape = function htmlEscape(string) {
    if (htmlTestRegexp.test(string)) {
      return string.replace(htmlReplaceRegexp, htmlReplacement);
    } else {
      return string;
    }
  };

  I18n.baseI18nT = I18n.t;

  I18n.text = I18n.t = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var lastOption = args[args.length - 1];
    var includesOptions = typeof lastOption !== 'string';
    var originalOpts = includesOptions && lastOption ? args[args.length - 1] : {};
    var key = includesOptions ? args.slice(0, args.length - 1).join('.') : args.join('.');
    var modifiedOpts = {}; // Copy originalOpts to modifiedOpts, formatting numeric params and escaping others along the way

    for (var optName in originalOpts) {
      if (originalOpts.hasOwnProperty(optName)) {
        var optValue = originalOpts[optName];

        if (optValue != null) {
          modifiedOpts[optName] = I18n.formatParam(optName, optValue);
        }
      }
    }

    if (!modifiedOpts.locale && I18n.lang !== 'en' && !I18n.langEnabled && !I18n.publicPage) {
      I18n.debugLog('Forcing translation in English, lang is not enabled');
      modifiedOpts.locale = 'en';
    } // Attach the translation key to the options object for missingPlaceholder


    modifiedOpts.__scope = key; // Warn if I18n isn't ready yet (#296)

    if (I18n.fired && !I18n.fired.ready) {
      var tooEarlyError = new Error("I18n.text called before ready with key '" + key + "' - See go/i18n-help for more info");
      setTimeout(function () {
        throw tooEarlyError;
      }, 0);
    }

    return I18n.baseI18nT(key, modifiedOpts);
  };

  I18n.html = function (key, opts) {
    if (opts == null) {
      opts = {};
    }

    var gap = '';

    if (opts.useGap === true || opts.noGap === false) {
      gap = ' ';
    }

    return gap + "<i18n-string data-key='" + key + "' data-locale-at-render='" + I18n.locale + "'>" + I18n.text(key, opts) + "</i18n-string>" + gap;
  };

  I18n.formatNumber = function (val, opts) {
    if (opts == null) {
      opts = {};
    }

    if (opts.abbreviate) {
      opts = I18n.prepareOptions(opts, ABBREVIATE_DEFAULTS);

      if (typeof opts.abbreviate === 'string') {
        opts.type = opts.abbreviate;
      }

      return I18n.abbreviateNumber(val, opts);
    }

    return I18n.toNumber(val, opts);
  };

  I18n.formatPercentage = function (val, opts) {
    if (opts == null) {
      opts = {};
    }

    return I18n.toPercentage(val, opts);
  };

  I18n.formatCurrency = function (val, opts) {
    if (opts == null) {
      opts = {};
    }

    if (!I18n.currencySymbols['USD']) {
      console.error('It looks like currency data is not available. Are you using the new I18n loader and forgot to import currencies? See go/new-i18n');
    }

    if (opts.currencyCode) {
      var currencyData = I18n.currencySymbols[opts.currencyCode];

      if (currencyData) {
        if (opts.unit == null) {
          opts.unit = currencyData.symbol;
        }

        var decimalDigits = currencyData.decimal_digits;

        if (currencyData.alternative_decimal_digits && val % 1 !== 0) {
          decimalDigits = currencyData.alternative_decimal_digits;
        }

        if (opts.precision == null) {
          opts.precision = decimalDigits;
        }
      }
    }

    if (!opts.unit && !opts.useCurrencyCode) {
      console.warn('I18n: Missing or invalid currencyCode in call to formatCurrency. See https://git.hubteam.com/HubSpot/I18n/issues/59');
    }

    if (opts.abbreviate) {
      opts = I18n.prepareOptions(opts, ABBREVIATE_DEFAULTS);

      if (typeof opts.abbreviate === 'string') {
        opts.type = opts.abbreviate;
      } // Format an arbitrary number and replace it with the abbreviation, to preserve the sign/unit order


      var signedNumber = val >= 0 ? 2 : -2;
      return I18n.toCurrency(signedNumber, opts).replace('2', I18n.abbreviateNumber(Math.abs(val), opts));
    } else {
      return I18n.toCurrency(val, opts);
    }
  };

  I18n.formatSize = I18n.toHumanSize;
  var NUMERAL_OR_SIGN_OR_E = /\d|\+|-|e/i;

  I18n.parseNumber = function (string, options) {
    options = I18n.prepareOptions(options, I18n.lookup('number.format', {
      locale: (options || {}).locale
    }), I18n.NUMBER_FORMAT);

    if (typeof string === 'number') {
      return string;
    } else if (typeof string !== 'string') {
      return NaN;
    } // Remove all whitespace and replace first instance of MINUS SIGN with HYPHEN MINUS


    string = string.replace(/\s/g, '').replace('−', '-'); // Iterate through all characters in the string and return NaN if we encounter an invalid character

    var buffer = '';

    for (var _i = 0, _Array$from = Array.from(string); _i < _Array$from.length; _i++) {
      var char = _Array$from[_i];

      if (char.match(NUMERAL_OR_SIGN_OR_E)) {
        buffer += char;
      } else if (char === options.separator) {
        buffer += '.';
      } else if (char === options.delimiter) {
        continue;
      } else {
        return NaN;
      }
    } // Attempt to parse what's left


    return parseFloat(buffer);
  };

  I18n.missingNotifications = [];

  var missingNotificationWrapper = function missingNotificationWrapper(originalFunction, eventName, sendSentries, originalArgs, sentryOptions) {
    if (sentryOptions == null) {
      sentryOptions = {};
    }

    var message = originalFunction.apply(I18n, originalArgs);
    var sentryMessage = sentryOptions.message || message;

    if (I18n.missingNotifications.indexOf(sentryMessage) < 0) {
      I18n.missingNotifications.push(sentryMessage);
      var missingNoticationError = new Error("I18n: " + sentryMessage);
      var extraErrorMetadata = {
        i18nErrorType: eventName,
        currentLocale: I18n.langEnabled ? I18n.locale : 'en-us',
        translationKey: sentryOptions.translationKey,
        placeholderName: sentryOptions.placeholderName
      };

      if (window.newrelic) {
        window.newrelic.noticeError(missingNoticationError, extraErrorMetadata);
      }

      if (sendSentries && window.Raven) {
        window.Raven.captureException(missingNoticationError, {
          extra: extraErrorMetadata
        });
      }

      try {
        if (localStorage.getItem('TRACK_I18N_MISSING_TRANSLATIONS')) {
          localStorage.setItem('I18N_MISSING_TRANSLATIONS', I18n.missingNotifications);
        }
      } catch (e) {//ignore
      }
    } // Trigger event if in browser context (trigger not currently around in node/schablone)


    if (typeof I18n.trigger === 'function') {
      I18n.trigger(eventName, message);
    }

    return message;
  };

  I18n.sendSentryOnMissingTranslations = true;
  var originalMissingTranslation = I18n.missingTranslation;

  I18n.missingTranslation = function (scope) {
    var missingTranslationMessage = 'Missing translation: "' + scope + '"';
    console.warn("I18n: " + missingTranslationMessage);
    var sentryOptions = {
      translationKey: scope,
      message: missingTranslationMessage
    };
    return htmlEscape(missingNotificationWrapper(originalMissingTranslation, 'missingTranslation', I18n.sendSentryOnMissingTranslations, [scope], sentryOptions));
  };

  I18n.sendSentryOnMissingValues = true;
  var originalMissingValue = I18n.missingPlaceholder;

  I18n.missingPlaceholder = function (placeholder, message, options) {
    var missingPlaceholderMessage = "Missing placeholder: " + placeholder + " in \"" + options.__scope + "\"";
    var sentryOptions = {
      message: missingPlaceholderMessage,
      translationKey: options.__scope,
      placeholderName: placeholder
    };
    console.warn("I18n: " + missingPlaceholderMessage);
    return missingNotificationWrapper(originalMissingValue, 'missingPlaceholder', I18n.sendSentryOnMissingValues, [placeholder, message, options], sentryOptions);
  };

  if (I18n.lang == null) {
    Object.defineProperty(I18n, 'lang', {
      get: function get() {
        return I18n.locale.split('-')[0];
      }
    });
  } // Performs "oxford comma"-style list joining according to each locale's settings.
  // Based off the Rails `Array#to_sentence` function.
  //
  //    I18n.formatList([1,2,3])  # => "1, 2, and 3"
  //    I18n.formatList([1,2,3], { locale: 'ja' })  // => "1と2と3"
  //
  //    I18n.formatList([1,2], {
  //      twoWordsConnector: '  AND  '
  //    })  // => "1  AND  2"
  //
  //    I18n.formatList([1,2,3], {
  //      wordsConnector: '|'
  //    })  // => "1|2, and 3"
  //
  //    I18n.formatList([1,2,3], {
  //      wordsConnector: '|',
  //      lastWordConnector: '&&&'
  //    })  // => "1|2&&&3"
  //
  //    // And assuming that the `foo.bar` key is defined like this...
  //    //
  //    //  en:
  //    //    foo:
  //    //      bar:
  //    //        one: {{ count }} other
  //    //        other: {{ count }} others
  //
  //    I18n.formatList([1,2,3,4,5], {
  //      limit: 4,
  //      excessKey: 'foo.bar'
  //    });  // => " 1, 2, 3, and 1 other"
  //
  //    I18n.formatList([1,2,3,4,5], {
  //      limit: 3,
  //      excessKey: 'foo.bar'
  //    });  // => " 1, 2, 3, and 2 others"
  //


  var CONNECTOR_DEFAULTS = {
    inclusive: {
      wordsConnector: '|, ',
      twoWordsConnector: '| and ',
      lastWordConnector: '|, and '
    },
    exclusive: {
      wordsConnector: '|, ',
      twoWordsConnector: '| or ',
      lastWordConnector: '|, or '
    }
  };

  var interleave = function interleave(between, items) {
    var lastIndex = items.length - 1;
    return items.reduce(function (acc, item, index) {
      acc.push(item);

      if (index !== lastIndex) {
        acc.push(between);
      }

      return acc;
    }, []);
  };

  I18n.formatListArray = function (list, options) {
    var result;

    if (options == null) {
      options = {};
    }

    var _options = options,
        wordsConnector = _options.wordsConnector,
        twoWordsConnector = _options.twoWordsConnector,
        lastWordConnector = _options.lastWordConnector,
        limit = _options.limit,
        excessKey = _options.excessKey,
        exclusive = _options.exclusive;

    if (limit != null && limit <= 2) {
      throw new Error('The formatList limit must be 3 or larger');
    }

    if (limit != null && excessKey == null) {
      throw new Error('When using a limit in formatList, you must pass excessKey (that is a external, plurlized string reference)');
    }

    if (Array.isArray != null) {
      // Hack to use Array.isArray in a node envionment (since instanceof check won't work for arrays
      // created across vm/context boundaries)
      if (!Array.isArray(list)) {
        throw new Error('The first argument to I18n.formatList must be an array');
      }
    } else {
      if (!(list instanceof Array)) {
        throw new Error('The first argument to I18n.formatList must be an array');
      }
    } // Use passed options, then config for the locale, then defaults if missing


    var rootKey = 'number.human.array';
    var connectorType = 'inclusive';

    if (exclusive === true) {
      connectorType = 'exclusive';
    }

    wordsConnector = options.wordsConnector || I18n.text(rootKey + "." + connectorType + ".wordsConnector", {
      locale: options.locale
    }) || CONNECTOR_DEFAULTS[connectorType].wordsConnector;
    twoWordsConnector = options.twoWordsConnector || I18n.text(rootKey + "." + connectorType + ".twoWordsConnector", {
      locale: options.locale
    }) || CONNECTOR_DEFAULTS[connectorType].twoWordsConnector;
    lastWordConnector = options.lastWordConnector || I18n.text(rootKey + "." + connectorType + ".lastWordConnector", {
      locale: options.locale
    }) || CONNECTOR_DEFAULTS[connectorType].lastWordConnector;
    var length = list.length;

    if (length === 0) {
      return [];
    } else if (length === 1) {
      return [list[0]];
    } else if (length === 2) {
      return [list[0], twoWordsConnector, list[1]];
    } else if (limit == null || limit >= length) {
      result = interleave(wordsConnector, list.slice(0, -1));
      result.push(lastWordConnector);
      result.push(list[list.length - 1]);
      return result;
    } else {
      var excessString = I18n.text(excessKey, {
        count: list.length - limit,
        locale: options.locale
      });
      result = interleave(wordsConnector, list.slice(0, limit));
      result.push(lastWordConnector);
      result.push(excessString);
      return result;
    }
  };

  I18n.formatList = function (list, options) {
    if (options == null) {
      options = {};
    }

    return I18n.formatListArray(list, options).join('');
  };

  var ABBR_DIGIT_MAX = 15;
  var ABBR_NUMBER_MAX = Math.pow(10, ABBR_DIGIT_MAX);
  var ABBR_NUMBER_MIN = 1000; // Short number helpers (they use patterns set in `<locale>.human.abbreviated.(short|long)`)
  //
  // Standard options:
  //   - **locale**: sets the locale to use for formatting (defaults to current `I18n.locale`)
  //   - **separator**: overrides the separator—character between int and decimal digits—from the above locale
  //   - **delimiter**: overrides the delimiter—character between every 3 int digits—from the above locale
  // Advanced options (mostly borrowed from the Intl.NumberFormat spec):
  //   - **minIntegerDigits**: the minimum number of integer digits—digits to the left of the decimal—to show (default is 1). Use this to left pad integers, like `00001`
  //   - **minFractionDigits**: the minimum number of fractional digits—digits to the right of the decimal—to show (default is 0)
  //   - **maxFractionDigits**: the maximum number of fractional digits—digits to the right of the decimal—to show (default is `max(minFractionDigits, 0)`)
  //   - **minSignificantDigits**: the minimum number of any non-zersignficant digits to show (default is undefined or 1 if maxSignificantDigits is set)
  //   - **maxSignificantDigits**: the maximum number of any signficant digits to show (default is undefined or <large number> if minSignificantDigits is set)
  //   - **numDigitsToTruncateTo**: the desired number of integer digits. Cuts of the rest of the digits rounding up if needed (default is undefined)
  //   - **stripInsignificantZeros**: remove all 0 decimal digits that at end (default is true unless any min/max fraction/significant digit option is set)

  I18n.advancedFormatNumber = function (number, opts) {
    var formattedNumber;

    if (opts == null) {
      opts = {};
    }

    opts = this.prepareOptions(opts, I18n.lookup('number.format', {
      locale: opts.locale
    }), {
      separator: '.',
      delimiter: ','
    });
    var _opts = opts,
        separator = _opts.separator,
        delimiter = _opts.delimiter,
        numDigitsToTruncateTo = _opts.numDigitsToTruncateTo,
        maxThreshold = _opts.maxThreshold,
        minThreshold = _opts.minThreshold,
        minIntegerDigits = _opts.minIntegerDigits,
        maxSignificantDigits = _opts.maxSignificantDigits,
        minSignificantDigits = _opts.minSignificantDigits,
        maxFractionDigits = _opts.maxFractionDigits,
        minFractionDigits = _opts.minFractionDigits,
        stripInsignificantZeros = _opts.stripInsignificantZeros; // SET DEFAULTS

    var negative = number < 0; // Threshold for when a number should be truncated/abbreviated

    if (minThreshold == null) {
      minThreshold = Number.NEGATIVE_INFINITY;
    }

    if (maxThreshold == null) {
      maxThreshold = Number.POSITIVE_INFINITY;
    } // Default to not stripping zeros if any advanced formatting is passed


    if (minFractionDigits != null || minSignificantDigits != null || maxFractionDigits != null || maxSignificantDigits != null) {
      if (stripInsignificantZeros == null) {
        stripInsignificantZeros = false;
      }
    } else {
      if (stripInsignificantZeros == null) {
        stripInsignificantZeros = true;
      }
    } // Set higher than numDigits for zero-padded small numbers


    if (minIntegerDigits == null) {
      minIntegerDigits = Math.max(numDigitsToTruncateTo != null ? numDigitsToTruncateTo : 0, 1);
    } // Control the total number signficant digits (includes both fractional
    // and not fractional digits). No defaults unless one of the two is set


    if (minSignificantDigits != null || maxSignificantDigits != null) {
      if (maxSignificantDigits == null) {
        maxSignificantDigits = ABBR_DIGIT_MAX;
      }

      if (minSignificantDigits == null) {
        minSignificantDigits = 1;
      }
    } // Control the number of fractional digits


    if (minFractionDigits == null) {
      minFractionDigits = 0;
    }

    if (maxFractionDigits == null) {
      maxFractionDigits = Math.max(minFractionDigits, 0);
    } // CALCULATE FORMATTING


    var absNumber = Math.abs(number);

    if (numDigitsToTruncateTo != null && minThreshold <= absNumber && absNumber < maxThreshold) {
      var truncateFactor = Math.max(0, I18n.util.log10Floor(absNumber) + 1 - numDigitsToTruncateTo);
      absNumber = absNumber / Math.pow(10, truncateFactor);
    }

    if (minSignificantDigits != null && maxSignificantDigits != null) {
      formattedNumber = I18n.util.toRawPrecision(absNumber, minSignificantDigits, maxSignificantDigits);
    } else {
      formattedNumber = I18n.util.toRawFixed(absNumber, minIntegerDigits, minFractionDigits, maxFractionDigits);
    } // AND THEN LOCALIZE


    var parts = formattedNumber.split('.');
    var intPart = parts[0];
    var decPart = parts[1];
    var buffer = [];

    while (intPart.length > 0) {
      buffer.unshift(intPart.substr(Math.max(0, intPart.length - 3), 3));
      intPart = intPart.substr(0, intPart.length - 3);
    }

    var localizedNumber = buffer.join(delimiter);

    if (stripInsignificantZeros && decPart) {
      decPart = decPart.replace(/0+$/, '');
    }

    if (decPart) {
      localizedNumber += separator + decPart;
    }

    if (negative) {
      localizedNumber = "\u2212" + localizedNumber;
    }

    return localizedNumber;
  };

  var getAbbreviationKey = function getAbbreviationKey(number) {
    number = Math.abs(number);

    var zeroes = _toConsumableArray(Array(Math.floor(number).toString().length - 1).keys()).map(function () {
      return '0';
    }).join('');

    return "1" + zeroes;
  };

  var parseAbbreviatePattern = function parseAbbreviatePattern(pattern) {
    var match = pattern.match(/^([^0]*)(0+)(.*)$/);

    if (match) {
      var _match = _slicedToArray(match, 4),
          __ = _match[0],
          prefix = _match[1],
          digitString = _match[2],
          suffix = _match[3];

      var numDigits = digitString.length;
      return {
        prefix: prefix,
        digitString: digitString,
        numDigits: numDigits,
        suffix: suffix
      };
    } else {
      throw new Error("Invalid abbreviation pattern: " + pattern);
    }
  };

  I18n.abbreviateNumber = function (val, opts) {
    if (opts == null) {
      opts = {};
    }

    var _opts2 = opts,
        type = _opts2.type,
        locale = _opts2.locale,
        separator = _opts2.separator,
        delimiter = _opts2.delimiter,
        stripInsignificantZeros = _opts2.stripInsignificantZeros,
        minIntegerDigits = _opts2.minIntegerDigits,
        maxSignificantDigits = _opts2.maxSignificantDigits,
        minSignificantDigits = _opts2.minSignificantDigits,
        maxFractionDigits = _opts2.maxFractionDigits,
        minFractionDigits = _opts2.minFractionDigits;

    if (type == null) {
      type = 'short';
    } // or 'long'


    var key = getAbbreviationKey(val);
    var abbrPattern = I18n.lookup("number.human.abbreviated." + type + "." + key, opts); // Deal with pluralizing (just take the first plural pattern and use it to determine pluralization)

    if (abbrPattern != null && typeof abbrPattern === 'object') {
      var samplePatternString = abbrPattern[Object.keys(abbrPattern)[0]];
      var samplePattern = parseAbbreviatePattern(samplePatternString);
      var sampleTruncatedNumber = I18n.advancedFormatNumber(val, {
        numDigitsToTruncateTo: samplePattern.numDigits,
        minThreshold: ABBR_NUMBER_MIN,
        maxThreshold: ABBR_NUMBER_MAX
      });
      var pluralizer = I18n.pluralization.get(locale);
      var pluralKeys = pluralizer(Math.abs(sampleTruncatedNumber));

      while (pluralKeys.length) {
        var pluralKey = pluralKeys.shift();

        if (abbrPattern[pluralKey] != null) {
          abbrPattern = abbrPattern[pluralKey];
          break;
        }
      }
    } // If this locale is unable to truncate for this number size, set
    // numDigits to a high value to prevent any truncation from happening


    if (['0', 0].includes(abbrPattern) || abbrPattern == null) {
      return I18n.advancedFormatNumber(val, {
        locale: locale,
        numDigitsToTruncateTo: 30,
        minThreshold: ABBR_NUMBER_MIN,
        maxThreshold: ABBR_NUMBER_MAX,
        minIntegerDigits: minIntegerDigits != null ? minIntegerDigits : 1,
        // Need to set so it doesn't default to the large numDigitsToTruncateTo value
        minSignificantDigits: minSignificantDigits,
        maxSignificantDigits: maxSignificantDigits,
        minFractionDigits: minFractionDigits,
        maxFractionDigits: maxFractionDigits,
        separator: separator,
        delimiter: delimiter,
        stripInsignificantZeros: stripInsignificantZeros
      }); // Otherwise, truncate normally
    } else {
      var abbrFormat = parseAbbreviatePattern(abbrPattern);
      var formattedTruncatedNumber = I18n.advancedFormatNumber(val, {
        locale: locale,
        numDigitsToTruncateTo: abbrFormat.numDigits,
        minThreshold: ABBR_NUMBER_MIN,
        maxThreshold: ABBR_NUMBER_MAX,
        minIntegerDigits: minIntegerDigits,
        minSignificantDigits: minSignificantDigits,
        maxSignificantDigits: maxSignificantDigits,
        minFractionDigits: minFractionDigits,
        maxFractionDigits: maxFractionDigits,
        separator: separator,
        delimiter: delimiter,
        stripInsignificantZeros: stripInsignificantZeros
      });
      return "" + abbrFormat.prefix + formattedTruncatedNumber + abbrFormat.suffix;
    }
  }; // interpolateToArray function to translate strings while preserving React element params (#108)


  I18n.interpolateToArray = function (key, options, escapeFunction) {
    var modifiedOpts = I18n.prepareOptions(options);
    modifiedOpts.__scope = key;
    var result = [];

    if (!options.locale && !I18n.langEnabled && !I18n.publicPage) {
      I18n.debugLog('Forcing translation in English, lang is not enabled');
      modifiedOpts.locale = 'en';
    }

    var remainingMessage = I18n.lookup(key, modifiedOpts);

    if (remainingMessage == null) {
      return [I18n.missingTranslation(key)];
    }

    if (remainingMessage === Object(remainingMessage) && this.isSet(options.count)) {
      if (options.count === 0 && remainingMessage.zero) {
        remainingMessage = remainingMessage.zero;
      } else if (options.count === 1 && remainingMessage.one) {
        remainingMessage = remainingMessage.one;
      } else {
        remainingMessage = remainingMessage.other;
      }
    }

    var i = 0;
    var match = I18n.placeholder.exec(remainingMessage);

    while (match) {
      // Custom HubSpot change for default escaping of params
      var prefix = remainingMessage.substring(0, match.index);

      if (prefix !== '') {
        result.push(escapeFunction('text-chunk', prefix, i++));
      }

      var optName = match[1];
      var rawOptValue = modifiedOpts[optName] != null ? modifiedOpts[optName] : I18n.missingPlaceholder(optName, remainingMessage, modifiedOpts);
      var escapedOptValue = escapeFunction(optName, rawOptValue, i++);

      if (escapedOptValue !== '') {
        result.push(escapedOptValue);
      }

      remainingMessage = remainingMessage.substring(match.index + match[0].length); // Reset `lastIndex` because we are re-using the same regex (and it maintains state when doing `exec`)

      I18n.placeholder.lastIndex = 0;
      match = I18n.placeholder.exec(remainingMessage);
    }

    if (remainingMessage !== '') {
      result.push(escapeFunction('text-chunk', remainingMessage, i++));
    }

    return result;
  }; // formatParam function to turn SafeStrings into strings, HTML-escape string primitives, and format numbers


  I18n.formatParam = function (optName, optValue) {
    if (typeof optValue === 'number') {
      if (isNaN(optValue)) {
        return null; // don't display NaN
      }

      if (optName === 'count') {
        return Number(optValue);
      }

      if (optName.toLowerCase() === 'portalid') {
        console.warn('The use of params named "portalId" in externalized strings is deprecated. You should wrap it, like so "I18n.t(key, { portalId: I18n.SafeString(portalId) })", to prevent it from being automatically formatted. See HubSpot/I18n#109');
        return String(optValue);
      } else {
        return I18n.formatNumber(optValue);
      }
    } else if (optValue instanceof I18n.SafeString) {
      return optValue.toString();
    } else if (optValue != null) {
      return htmlEscape(String(optValue));
    } else {
      return optValue;
    }
  };

  var zeroAsOnePlural = function zeroAsOnePlural(count) {
    var validCount = count === 0 ? 1 : count;
    return I18n.pluralization.default(validCount);
  };

  I18n.pluralization.fr = zeroAsOnePlural;
})();

(function () {
var DATE_STRING_ZONE_ABBR_REGEX, INTL_STRING_ZONE_ABBR_REGEX, origZoneAbbr, userZoneAbbr,
  slice = [].slice;

INTL_STRING_ZONE_ABBR_REGEX = /\s+(\S+)$/;

DATE_STRING_ZONE_ABBR_REGEX = /[A-Z]{2}\S+/;

I18n.moment.fn.portalTz = function() {
  var args, moment;
  args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  if (args.length === 0) {
    moment = I18n.moment.fn.tz.call(this, I18n.timezone);
  } else {
    throw new Error("You cannot pass any parameters to portalTz when called on a moment instance. Did you mean to call `I18n.moment.portalTz(...)` instead?");
  }
  return moment;
};

I18n.moment.portalTz = function() {
  var args, moment, ref;
  args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  if (args.length > 0) {
    moment = (ref = I18n.moment.tz).call.apply(ref, [this].concat(slice.call(args), [I18n.timezone]));
  } else {
    moment = I18n.moment.utc().tz(I18n.timezone);
  }
  return moment;
};

I18n.moment.userTz = function() {
  var args, moment, ref;
  args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  if (args.length > 0) {
    moment = (ref = I18n.moment).call.apply(ref, [this].concat(slice.call(args)));
  } else {
    moment = I18n.moment();
  }
  moment.zoneAbbr = userZoneAbbr;
  return moment;
};

origZoneAbbr = I18n.moment.fn.zoneAbbr;

I18n.moment.fn.zoneAbbr = function() {
  if (this._z === void 0) {
    console.warn('I18n: Time zone abbreviations are not available on moments created with I18n.moment(). Switch to I18n.moment.userTz(), I18n.moment.portalTz(), or I18n.moment.utc(), as appropriate: https://git.hubteam.com/HubSpot/I18n/blob/master/docs/dates.md');
  }
  return origZoneAbbr.call(this);
};

userZoneAbbr = function() {
  var date, match;
  date = this.toDate();
  I18n.intlTimeZoneFormatter || (I18n.intlTimeZoneFormatter = typeof Intl !== "undefined" && Intl !== null ? typeof Intl.DateTimeFormat === "function" ? Intl.DateTimeFormat('en', {
    timeZoneName: 'short'
  }) : void 0 : void 0);
  if (I18n.intlTimeZoneFormatter) {
    match = I18n.intlTimeZoneFormatter.format(date).match(INTL_STRING_ZONE_ABBR_REGEX);
    if (match && match[1]) {
      return match[1];
    }
  }
  match = date.toString().match(DATE_STRING_ZONE_ABBR_REGEX);
  if (match) {
    return match[0];
  }
  return '';
};
}());

"use strict";
'use es6';
'babel noModule';

(function () {
  I18n.formatDuration = function (duration) {
    console.warn('I18n.formatDuration is deprecated and will be removed from future I18n versions. Please move to the util in I18n/utils/formatRelativeDuration');
    var minutes = Math.floor(duration.asMinutes());
    var hours = Math.floor(duration.asHours());

    if (minutes < 60) {
      return I18n.text('i18n.duration.minutes', {
        minutes: minutes
      });
    }

    if (minutes % 60 === 0) {
      return I18n.text('i18n.duration.hours', {
        hours: hours
      });
    }

    return I18n.text('i18n.duration.hoursAndMinutes', {
      hours: hours,
      minutes: minutes % 60
    });
  };
})();

"use strict";
'use es6';
'babel noModule';

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  var _this = this;

  I18n.partial = function () {
    var _I18n$partial;

    for (var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++) {
      keys[_key] = arguments[_key];
    }

    var result = function result() {
      var _I18n;

      for (var _len2 = arguments.length, nextKeys = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        nextKeys[_key2] = arguments[_key2];
      }

      var allKeys = [].concat(keys, nextKeys);
      return (_I18n = I18n).text.apply(_I18n, _toConsumableArray(allKeys));
    };

    result.partial = (_I18n$partial = I18n.partial).bind.apply(_I18n$partial, [_this].concat(keys));
    return result;
  };
})();

(function () {
var slice = [].slice;

I18n.when('locale:loaded locale:failed locale:noop', function() {
  return I18n.trigger('locale:ready');
});

I18n.when('timezone:loaded timezone:failed timezone:noop', function() {
  return I18n.trigger('timezone:ready');
});

I18n.waitFor = function() {
  var deps, pro;
  deps = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  pro = new I18n.Promise;
  I18n.when('locale:ready', function() {
    return I18n.loadLocale(I18n.locale, function() {
      return I18n.when('timezone:ready', function() {
        return pro.resolve();
      });
    }, deps);
  });
  return pro;
};

I18n.loadedProjects = function() {
  var project, results;
  results = [];
  for (project in I18n.translationsLoaded) {
    results.push(project);
  }
  return results;
};

I18n.whenDOMContentLoaded(function() {
  var keys;
  keys = I18n.loadedProjects();
  return I18n.when('locale:ready', function() {
    return I18n.loadLocale(I18n.locale, function() {
      return I18n.when('timezone:ready', function() {
        return I18n.trigger('ready');
      });
    }, null, I18n.langEnabled);
  });
}, false);

I18n.whenDOMContentLoaded(function() {
  var timeout;
  timeout = setTimeout(function() {
    console.error("I18n locale / timezone loading timed out");
    I18n.trigger('timeout');
    return I18n.trigger('ready');
  }, 2500);
  return I18n.when('ready', function() {
    return clearTimeout(timeout);
  });
}, false);
}());

(function () {
var pending;

I18n.buildStaticPath = function(project, path) {
  var message, ref, ref1, versionForProject;
  if ((typeof hubspot !== "undefined" && hubspot !== null ? (ref = hubspot.bender) != null ? ref.staticDomainPrefix : void 0 : void 0) == null) {
    message = "I18n error: it doesn't seem like the bender mixin has been included on the page";
    console.error(message);
    if (typeof Raven !== "undefined" && Raven !== null) {
      if (typeof Raven.captureMessage === "function") {
        Raven.captureMessage(message);
      }
    }
  } else if (!(typeof I18n !== "undefined" && I18n !== null ? (ref1 = I18n.translationsAvailable[project]) != null ? ref1.en : void 0 : void 0)) {
    message = "I18n error: no translation strings are available for '" + project + "'";
    console.error(message);
    if (typeof Raven !== "undefined" && Raven !== null) {
      if (typeof Raven.captureMessage === "function") {
        Raven.captureMessage(message);
      }
    }
  } else {
    versionForProject = I18n.translationsAvailable[project].en;
    return hubspot.bender.staticDomainPrefix + "/" + project + "/" + versionForProject + path;
  }
};

I18n.buildLocalePath = function(project, lang) {
  return I18n.buildStaticPath(project, "/lang/" + lang + ".js");
};

pending = {};

I18n.loadProjectLocale = function(project, locale, successCb, failureCb) {
  var fail, localeLowercased, localeMinusRegion, localeOrLangToLoad, script, success;
  if (pending[project] == null) {
    pending[project] = {};
  }
  if (pending[project][locale] != null) {
    pending[project][locale].successCallbacks.push(successCb);
    pending[project][locale].failureCallbacks.push(failureCb);
    return;
  }
  pending[project][locale] = {
    successCallbacks: [successCb],
    failureCallbacks: [failureCb]
  };
  localeLowercased = locale.toLowerCase();
  localeMinusRegion = localeLowercased.split('-')[0];
  fail = function() {
    var callbacks, i, len, message, results;
    if (localeMinusRegion !== localeLowercased) {
      message = "Locale " + locale + " (or lang " + localeMinusRegion + ") strings not available in project " + project + ", bailing";
    } else {
      message = "Lang " + locale + " strings not available in project " + project + ", bailing";
    }
    console.warn(message);
    callbacks = pending[project][locale].failureCallbacks;
    pending[project][locale] = null;
    results = [];
    for (i = 0, len = callbacks.length; i < len; i++) {
      failureCb = callbacks[i];
      results.push(typeof failureCb === "function" ? failureCb() : void 0);
    }
    return results;
  };
  success = function(successInfo) {
    var callbacks, i, len, results;
    callbacks = pending[project][locale].successCallbacks;
    pending[project][locale] = null;
    results = [];
    for (i = 0, len = callbacks.length; i < len; i++) {
      successCb = callbacks[i];
      results.push(typeof successCb === "function" ? successCb(successInfo) : void 0);
    }
    return results;
  };
  if (!I18n.translationsAvailable && !I18n.translationsAvailable[project]) {
    return fail();
  }
  if (I18n.translationsAvailable[project][localeLowercased]) {
    localeOrLangToLoad = localeLowercased;
  } else if (I18n.translationsLoaded[project][localeMinusRegion]) {
    I18n.debugLog(project + " doesn't have " + locale + " strings, but does have " + localeMinusRegion + " strings. Falling back to those (and they are already loaded).");
    return success({
      alreadyPresent: true
    });
  } else if (I18n.translationsAvailable[project][localeMinusRegion]) {
    I18n.debugLog(project + " doesn't have " + locale + " strings, but does have " + localeMinusRegion + " strings. Falling back to those.");
    localeOrLangToLoad = localeMinusRegion;
  } else {
    return fail();
  }
  if (!localeOrLangToLoad) {
    throw new Error("Assert localeOrLangToLoad is not undefined");
  }
  script = document.createElement('script');
  document.querySelector('head').appendChild(script);
  I18n.debugLog("fetching " + localeOrLangToLoad + " strings for " + project);
  script.addEventListener('load', function() {
    var callbacks, i, len, results;
    script.parentNode.removeChild(script);
    callbacks = pending[project][locale].successCallbacks;
    pending[project][locale] = null;
    results = [];
    for (i = 0, len = callbacks.length; i < len; i++) {
      successCb = callbacks[i];
      results.push(typeof successCb === "function" ? successCb() : void 0);
    }
    return results;
  }, false);
  script.addEventListener('error', function() {
    var callbacks, i, len, results;
    console.error("I18n error: Error loading language file");
    callbacks = pending[project][locale].failureCallbacks;
    pending[project][locale] = null;
    results = [];
    for (i = 0, len = callbacks.length; i < len; i++) {
      failureCb = callbacks[i];
      results.push(typeof failureCb === "function" ? failureCb() : void 0);
    }
    return results;
  }, false);
  return script.src = I18n.buildLocalePath(project, localeOrLangToLoad);
};

I18n.loadLocale = function(locale, cb, projectsToLoad, shouldLoadLocale) {
  var callbackAlreadyCalled, check, i, len, project, projects, ref, remaining;
  if (shouldLoadLocale == null) {
    shouldLoadLocale = true;
  }
  projects = projectsToLoad != null ? projectsToLoad : I18n.loadedProjects();
  remaining = projects.length;
  callbackAlreadyCalled = false;
  check = function() {
    if (remaining === 0 && callbackAlreadyCalled === false) {
      callbackAlreadyCalled = true;
      return typeof cb === "function" ? cb(locale) : void 0;
    }
  };
  for (i = 0, len = projects.length; i < len; i++) {
    project = projects[i];
    if (shouldLoadLocale && (((ref = I18n.translationsLoaded[project]) != null ? ref[locale] : void 0) == null)) {
      (function(project) {
        var failureCb, successCb;
        return I18n.loadProjectLocale(project, locale, successCb = function(options) {
          if (!(options != null ? options.alreadyPresent : void 0)) {
            I18n.debugLog(locale + " strings loaded dynamically for " + project);
          }
          remaining--;
          return check();
        }, failureCb = function() {
          I18n.debugLog(locale + " strings failed to load for " + project);
          remaining--;
          return check();
        });
      })(project);
    } else {
      I18n.debugLog(locale + " strings already loaded for " + project);
      remaining--;
    }
  }
  return check();
};

I18n.changeLocale = function(locale, cb, projectsToLoad, shouldLoadLocale) {
  var deferred, i, len, ref, updateLocaleState, whitelistLocale, whitelisted;
  if (shouldLoadLocale == null) {
    shouldLoadLocale = true;
  }
  deferred = new I18n.Promise;
  if (I18n.localeWhitelist instanceof Array) {
    whitelisted = false;
    ref = I18n.localeWhitelist;
    for (i = 0, len = ref.length; i < len; i++) {
      whitelistLocale = ref[i];
      if (locale.indexOf(whitelistLocale) === 0) {
        whitelisted = true;
        break;
      }
    }
    if (!whitelisted) {
      I18n.debugLog("change to " + locale + " prevented by I18n.localeWhitelist: " + I18n.localeWhitelist);
      if (typeof cb === "function") {
        cb(I18n.locale);
      }
      deferred.resolve();
      return deferred;
    }
  }
  updateLocaleState = function(locale) {
    var dateLocale;
    I18n.locale = locale;
    dateLocale = locale;
    if (locale === 'en-ie') {
      dateLocale = 'en-gb';
    }
    if (locale === 'en-in') {
      dateLocale = 'en-au';
    } else if (locale === 'en-nz') {
      dateLocale = 'en-au';
    } else if (locale === 'es-mx') {
      dateLocale = 'es';
    } else if (locale === 'es-ar') {
      dateLocale = 'es-do';
    } else if (locale === 'es-co') {
      dateLocale = 'es-do';
    }
    if (I18n.moment.locale != null) {
      I18n.moment.locale(dateLocale);
    } else {
      I18n.moment.lang(dateLocale);
    }
    I18n.trigger('change:locale', {
      locale: locale
    });
    deferred.resolve();
    return typeof cb === "function" ? cb(locale) : void 0;
  };
  I18n.loadLocale(locale, updateLocaleState, projectsToLoad, shouldLoadLocale);
  return deferred;
};

I18n.changeTimezone = function(timezone) {
  var e, error;
  try {
    I18n.moment.tz(timezone);
  } catch (error) {
    e = error;
    console.error("Error: '" + timezone + "' isn't in our timezone database");
    return;
  }
  I18n.timezone = timezone;
  return I18n.trigger('change:timezone', {
    timezone: timezone
  });
};
}());

(function () {
I18n.langs = {
  en: {
    label: 'English'
  },
  de: {
    label: 'Deutsch'
  },
  ja: {
    label: '日本語'
  },
  es: {
    label: 'Español'
  },
  pt: {
    label: 'Português'
  }
};
}());

(function () {
var availableIn,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

availableIn = ['en'];

I18n.urlPrefix = '';

I18n.locationIn = function(locale) {
  var path, prefixEndsWithSlash, ref, tester, urlPrefix, urlPrefixWithSlash;
  path = document.location.pathname;
  urlPrefix = urlPrefixWithSlash = (ref = I18n.urlPrefix) != null ? ref : '';
  prefixEndsWithSlash = urlPrefix[urlPrefix.length - 1] === "/";
  if (prefixEndsWithSlash) {
    urlPrefix = urlPrefix.substring(0, urlPrefix.length - 1);
  }
  if (urlPrefix) {
    urlPrefixWithSlash = urlPrefix + '/';
  }
  tester = "^/" + urlPrefixWithSlash.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') + ("(" + (I18n.availableInLocales.join('|')) + ")(/|$)");
  if (new RegExp(tester).test(path)) {
    path = path.substring(3 + urlPrefixWithSlash.length) || '/';
  } else if (urlPrefixWithSlash && new RegExp("^/" + urlPrefixWithSlash).test(path)) {
    path = path.substring(urlPrefixWithSlash.length);
  }
  if (locale === 'en' || indexOf.call(I18n.availableInLocales, locale) < 0) {
    if (urlPrefixWithSlash) {
      return '/' + urlPrefix + path + document.location.search + document.location.hash;
    } else {
      return path + document.location.search + document.location.hash;
    }
  } else {
    return '/' + urlPrefixWithSlash + locale + path + document.location.search + document.location.hash;
  }
};

I18n.availableIn = function(langs, options) {
  if (options == null) {
    options = {};
  }
  availableIn = langs;
  I18n.localeInURL = options.inURL || false;
  return I18n.trigger('change:available', availableIn);
};

if (I18n.availableInLocales == null) {
  Object.defineProperty(I18n, 'availableInLocales', {
    get: function() {
      var ai;
      ai = availableIn.slice(0);
      if (ai.indexOf(I18n.lang) === -1) {
        ai.push(I18n.lang);
      }
      return ai;
    }
  });
}
}());

(function () {
if (typeof window.I18n === 'undefined') {
  window.I18n = {};
}

I18n.setPublicLangPreference = function(lang) {
  var cookieSetterFunc, ref;
  if ((typeof window !== "undefined" && window !== null ? window.Cookies : void 0) != null) {
    cookieSetterFunc = Cookies.set;
  } else if (typeof window !== "undefined" && window !== null ? (ref = window.jQuery) != null ? ref.cookie : void 0 : void 0) {
    cookieSetterFunc = jQuery.cookie;
  }
  if (cookieSetterFunc != null) {
    return cookieSetterFunc('hubspot.lang.preference', lang, {
      expires: 730,
      path: '/',
      domain: I18n.cookieDomain()
    });
  }
};

I18n.getPublicLangPreference = function() {
  var ref, ref1;
  if (typeof navigator !== "undefined" && navigator !== null ? (ref = navigator.languages) != null ? ref[0] : void 0 : void 0) {
    return navigator.languages[0];
  } else if ((typeof window !== "undefined" && window !== null ? window.Cookies : void 0) != null) {
    return Cookies.get('hubspot.lang.preference');
  } else if (typeof window !== "undefined" && window !== null ? (ref1 = window.jQuery) != null ? ref1.cookie : void 0 : void 0) {
    return window.jQuery.cookie('hubspot.lang.preference');
  }
};

I18n.cookieDomain = function() {
  if (!window) {
    return;
  }
  return window.location.hostname.split('.').slice(-2).join('.');
};
}());

(function () {
var checkLocaleInURL, getParams;

getParams = (function() {
  var map, query;
  query = location.search.substr(1);
  map = {};
  query.replace(/([^&=]+)=?([^&]*)(?:&+|$)/g, function(match, key, value) {
    return map[key] = value;
  });
  return map;
})();

I18n.manualLocale = getParams.lang || ((function() {
  try {
    return typeof localStorage !== "undefined" && localStorage !== null ? localStorage.I18N_MANUAL_LANG : void 0;
  } catch (undefined) {}
})()) || window.I18N_MANUAL_LANG;

I18n.manualTimezone = ((function() {
  try {
    return typeof localStorage !== "undefined" && localStorage !== null ? localStorage.I18N_TZ : void 0;
  } catch (undefined) {}
})()) || window.I18N_TZ;

if (I18n.manualLocale) {
  I18n.langEnabled = true;
}

if (I18n.manualLocale != null) {
  I18n.debugLog("locale manually set to " + I18n.manualLocale + " (and forcing localeEnabled to true)");
}

if (I18n.manualTimezone != null) {
  I18n.debugLog("timezone manually set to " + I18n.manualTimezone);
}

if (I18n.publicPage && I18n.getPublicLangPreference()) {
  I18n.locale = I18n.getPublicLangPreference();
  I18n.debugLog("initially setting locale to " + I18n.locale + " on public page (via cookie)");
} else {
  I18n.locale = I18n.manualLocale || window.I18N_RENDERED_LANG || I18n.locale || (typeof navigator !== "undefined" && navigator !== null ? navigator.language : void 0) || (typeof navigator !== "undefined" && navigator !== null ? navigator.userLanguage : void 0) || 'en';
  if (I18n.locale.indexOf('_') >= 0) {
    I18n.locale = I18n.locale.replace('_', '-');
  }
  if (typeof I18n.locale === 'string' && I18n.locale.substring(0, 2) === 'pt') {
    I18n.locale = 'pt-br';
  } else if (I18n.locale === 'noNO' || I18n.locale === 'no') {
    I18n.locale = 'no-no';
  } else if (I18n.locale === 'zh-tw') {
    I18n.locale = 'zh-hk';
  } else if (I18n.locale === 'es-co') {
    I18n.locale = 'es-ar';
  } else if (I18n.locale === 'ar') {
    I18n.locale = 'ar-eg';
  } else if (I18n.locale === 'ca') {
    I18n.locale = 'ca-es';
  }
  I18n.debugLog("initially setting locale to " + I18n.locale);
}

I18n.timezone = I18n.manualTimezone || window.I18N_RENDERED_TZ || I18n.timezone || 'US/Eastern';

I18n.debugLog("initially setting timezone to " + I18n.timezone);

(checkLocaleInURL = function() {
  if (I18n.localeInURL) {
    if (!window.I18N_RENDERED_LANG) {
      console.error("I18N_RENDERED_LANG not found, are we rendering with Schablone and inheriting from the base template (w/ StyleGuideUI v2)?");
      return;
    }
    if (window.I18N_RENDERED_LANG !== I18n.lang) {
      I18n.debugLog("changing locale " + I18n.lang + " via checkLocaleInURL");
      return I18n.changeLocale(I18n.lang);
    }
  }
})();

I18n.on('change:available', checkLocaleInURL);

if (I18n.moment) {
  if (I18n.moment.locale != null) {
    I18n.moment.locale(I18n.locale);
  } else {
    I18n.moment.lang(I18n.locale);
  }
}
}());

(function () {
var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

hubspot.defineEager('hubspot.I18n.load', [], function() {
  var getPortalId, getPortalIdFromPath, getPortalIdFromQueryParam, load, loadFromEarlyRequesterOrCarmen, parsePortalIdFromString, pendingCBs, triggerCallbacks;
  parsePortalIdFromString = function(string, regex) {
    var idRe, portalId;
    idRe = regex.exec(string);
    portalId = idRe != null ? idRe[1] : void 0;
    return +portalId || void 0;
  };
  getPortalIdFromPath = function() {
    return parsePortalIdFromString(document.location.pathname, /^\/(?:[A-Za-z0-9-_]*)\/(\d+)(?:\/|$)/);
  };
  getPortalIdFromQueryParam = function() {
    return parsePortalIdFromString(document.location.search, /(?:\?|&)portalid=(\d+)/i);
  };
  getPortalId = function() {
    return getPortalIdFromPath() || getPortalIdFromQueryParam();
  };
  pendingCBs = [];
  triggerCallbacks = function(data) {
    var cb, i, len;
    for (i = 0, len = pendingCBs.length; i < len; i++) {
      cb = pendingCBs[i];
      cb(data);
    }
    return pendingCBs = [];
  };
  loadFromEarlyRequesterOrCarmen = function(cb, onError, loadLocaleFallback) {
    var earlyAuthRequest, ref;
    if (cb != null) {
      pendingCBs.push(cb);
    }
    earlyAuthRequest = (ref = window.quickFetch) != null ? ref.getRequestStateByName('api-verify') : void 0;
    if (earlyAuthRequest != null) {
      earlyAuthRequest.whenFinished((function(_this) {
        return function(apiVerifyData) {
          var langEnabled, locale, ref1, ref2, ref3, ref4, timezone;
          timezone = apiVerifyData != null ? (ref1 = apiVerifyData.portal) != null ? (ref2 = ref1.timezone) != null ? ref2.id : void 0 : void 0 : void 0;
          locale = apiVerifyData != null ? (ref3 = apiVerifyData.user) != null ? ref3.locale : void 0 : void 0;
          langEnabled = apiVerifyData != null ? (ref4 = apiVerifyData.user) != null ? ref4.lang_enabled : void 0 : void 0;
          if ((timezone != null) && (locale != null)) {
            return triggerCallbacks({
              timezone: timezone,
              locale: locale,
              langEnabled: langEnabled
            });
          } else if (loadLocaleFallback) {
            return loadLocaleFallback().then(triggerCallbacks);
          }
        };
      })(this));
      return earlyAuthRequest.onError((function(_this) {
        return function(xhr, statusCode, error) {
          return typeof loadLocaleFallback === "function" ? loadLocaleFallback().then(triggerCallbacks) : void 0;
        };
      })(this));
    } else if (loadLocaleFallback) {
      return loadLocaleFallback().then(triggerCallbacks);
    }
  };
  load = function(pid, loadLocaleFallback) {
    var portalID;
    portalID = pid || getPortalId();
    if (!portalID || I18n.manualLocale) {
      I18n.trigger('locale:noop');
    }
    if (!portalID || I18n.manualTimezone) {
      I18n.trigger('timezone:noop');
    }
    if (!portalID) {
      return;
    }
    return loadFromEarlyRequesterOrCarmen(function(arg) {
      var langEnabled, locale, ref, timezone;
      locale = arg.locale, timezone = arg.timezone, langEnabled = arg.langEnabled;
      I18n.debugLog("Carmen response: locale = " + locale + "  timezone = " + timezone + "  langEnabled = " + langEnabled);
      locale || (locale = I18n.locale);
      if (I18n.publicPage) {
        I18n.debugLog("Forcing langEnabled to true for public page");
        langEnabled = true;
        if (I18n.getPublicLangPreference() && I18n.availableInLocales && (ref = I18n.getPublicLangPreference, indexOf.call(I18n.availableInLocales, ref) >= 0)) {
          I18n.debugLog("setting locale from public lang preference");
          locale = I18n.getPublicLangPreference();
        } else if (I18N_RENDERED_LANG) {
          I18n.debugLog("setting locale from I18N_RENDERED_LANG on public page");
          locale = I18N_RENDERED_LANG;
        }
      }
      if (!I18n.manualLocale) {
        if (indexOf.call(I18n.availableInLocales, locale) >= 0 || !I18n.publicPage) {
          I18n.langEnabled = langEnabled;
          I18n.debugLog("Lang enabled: " + langEnabled);
          I18n.debugLog(locale + " is available locale, changing...");
          I18n.changeLocale(locale, null, null, I18n.langEnabled).then(function(locale) {
            I18n.trigger('locale:loaded', {
              locale: locale
            });
            if (pid) {
              return I18n.trigger('readyWithPortalId');
            }
          }, function() {
            return I18n.trigger('locale:failed');
          });
        }
      }
      if (I18n.publicPage && !I18n.manualTimezone) {
        if (timezone) {
          I18n.changeTimezone(timezone);
          return I18n.trigger('timezone:loaded', {
            timezone: timezone
          });
        } else {
          return I18n.trigger('timezone:loaded');
        }
      }
    }, function() {
      console.error("Error loading locale/timezone");
      I18n.trigger('locale:failed');
      return I18n.trigger('timezone:failed');
    }, loadLocaleFallback);
  };
  load();
  return load;
});
}());

(function () {
var updateClass;

updateClass = function() {
  var html;
  html = document.querySelector('html');
  html.className = html.className.replace(/(^|\b)lang-[a-z]{2}($|\b)/, '');
  html.className += " lang-" + I18n.lang;
  return html.setAttribute('lang', I18n.locale);
};

I18n.whenDOMContentLoaded(updateClass);

I18n.on('change:locale', updateClass);
}());

(function () {
I18n.on('change:locale', function() {
  var el, elements, i, len, results;
  try {
    if ((typeof localStorage !== "undefined" && localStorage !== null ? localStorage.I18N_SHOW_KEYS : void 0) === 'true') {
      elements = document.querySelectorAll('i18n-string');
      if (elements != null) {
        results = [];
        for (i = 0, len = elements.length; i < len; i++) {
          el = elements[i];
          results.push(el.innerHTML = I18n.html(el.getAttribute('data-key'), JSON.parse(el.getAttribute('data-options'))));
        }
        return results;
      }
    }
  } catch (undefined) {}
});
}());

(function () {
I18n.title = function(key, options) {
  if (typeof document !== "undefined" && document !== null) {
    I18n.when('ready', function() {
      return document.title = I18n.text(key, options);
    });
    return '';
  } else {
    return I18n.text(key, options);
  }
};
}());

(function () {
var earlyAuthRequest, ref, setupTimezone, timezoneAlreadySetup;

timezoneAlreadySetup = false;

setupTimezone = function(arg) {
  var e, error, portal;
  portal = arg.portal;
  if (I18n.manualTimezone) {
    return;
  }
  if (timezoneAlreadySetup === true) {
    return;
  }
  try {
    if ((portal != null ? portal.timezone : void 0) && portal.timezone.id && portal.timezone['moment-data']) {
      timezoneAlreadySetup = true;
      if (!I18n.moment.tz.zone(portal.timezone.id)) {
        I18n.moment.tz.add(portal.timezone.id + "|" + portal.timezone['moment-data']);
      }
      I18n.changeTimezone(portal.timezone.id);
      return I18n.trigger('timezone:loaded');
    } else {
      return typeof Raven !== "undefined" && Raven !== null ? Raven.captureMessage("I18n failed to parse api-verify data: " + JSON.stringify(portal != null ? portal.timezone : void 0)) : void 0;
    }
  } catch (error) {
    e = error;
    console.error('Error timezone thing', e);
    return typeof Raven !== "undefined" && Raven !== null ? Raven.captureException(e) : void 0;
  }
};

earlyAuthRequest = (ref = window.quickFetch) != null ? ref.getRequestStateByName('api-verify') : void 0;

if (earlyAuthRequest != null) {
  earlyAuthRequest.whenFinished((function(_this) {
    return function(loginVerifyData) {
      return setupTimezone(loginVerifyData);
    };
  })(this));
}

window.addEventListener('hubspot:userinfochange', function(e) {
  return setupTimezone(e);
});
}());

(function () {

}());

